// Realistic Delhi NCR startup ecosystem placeholder content

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "News", href: "#news" },
  { label: "Articles", href: "#articles" },
  { label: "Events", href: "#events" },
  { label: "RFT", href: "#rft" },
];

export const teamDropdown = [
  { label: "Founders/Investors", href: "/founders-investors" },
  { label: "Mentors", href: "/mentors" },
];

export const moreDropdown = [
  { label: "Partner With Us", href: "#partner" },
  { label: "Advertise", href: "#advertise" },
  { label: "Contact", href: "/contact" },
];

export const curatedNews = [
  {
    id: 1,
    slug: "d2c-food-startup-anveshan-raises-150-crore-in-series-b-funding",
    tag: "FUNDING",
    status: "Draft",
    title:
      "D2C Food Startup Anveshan Raises ₹150 Crore in Series B Funding Led by Vertex Ventures",
    subtitle:
      "The Gurugram-based clean-label food brand known for A2 ghee, cold-pressed oils and raw honey has doubled its valuation to over $90 million, drawing backing from IFC, boAt's Aman Gupta and Swiggy's co-founder.",
    time: "2 Jun",
    published: "2 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/d2c-food-startup-anveshan-raises-150-crore-in-series-b-funding.jpg",
    pullQuote:
      '"The investment would help the company make high-quality clean food products accessible to a much larger consumer base." — Kuldeep Parewa, CEO & Co-founder, Anveshan',
    body: [
      "Gurugram-based D2C food startup Anveshan has raised ₹150 crore in a Series B funding round led by Vertex Ventures Southeast Asia & India, marking a major milestone in the company's growth journey. The round also saw participation from the International Finance Corporation (IFC), Swiggy co-founder Sriharsha Majety and existing investors including Wipro Consumer Care Ventures, Titan Capital, Force Ventures and boAt founders Aman Gupta and Sameer Mehta.",
      "Founded in 2020 by IIT Guwahati alumni Kuldeep Parewa, Akhil Kansal and Aayushi Khandelwal, Anveshan has built a strong presence in India's rapidly growing clean-label food segment. The startup offers products such as A2 ghee, cold-pressed oils, raw honey and Indian superfoods, focusing on transparency, traceability and minimally processed nutrition.",
      "The fresh capital will be used to strengthen Anveshan's manufacturing and sourcing ecosystem, expand into new product categories and scale its brand presence across India. The company also plans to invest in quality infrastructure, procurement systems and partnerships with traditional producers and micro-entrepreneurs.",
      "Anveshan has witnessed rapid growth over the past year. According to the company, it is currently operating at an annual revenue run rate of ₹280-300 crore and expects to close FY26 with revenues of ₹200-220 crore. The startup has also built a network of 16 manufacturing facilities across nine states, helping bring traditionally made food products to consumers nationwide.",
      "Speaking on the funding, CEO and co-founder Kuldeep Parewa said the investment would help the company make high-quality clean food products accessible to a much larger consumer base while strengthening its manufacturing and sourcing capabilities.",
      "The funding comes at a time when demand for clean-label, health-focused food products is rising across India. Anveshan says nearly 50-55% of its revenue now comes from Tier 2 and Tier 3 cities, highlighting growing consumer awareness around food quality and nutrition beyond major metros.",
      "With fresh capital, a rapidly expanding customer base, and growing investor confidence, Anveshan is positioning itself as one of the key startups shaping the future of India's clean and traceable food industry.",
    ],
  },
  {
    id: 2,
    slug: "simple-energy-raises-250-crore-as-ev-startup-accelerates-growth-ahead-of-ipo-plans",
    tag: "FUNDING",
    status: "Draft",
    title:
      "Simple Energy Raises ₹250 Crore as EV Startup Accelerates Growth Ahead of IPO Plans",
    subtitle:
      "EV startup Simple Energy has raised ₹250 crore in a Series B funding round to expand manufacturing, strengthen its retail network, and accelerate growth. The Bengaluru-based company is also targeting an IPO in FY28 as demand for electric scooters continues to rise.",
    time: "2 Jun",
    published: "2 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/simple-energy-raises-250-crore-as-ev-startup-accelerates-growth-ahead-of-ipo-plans.jpg",
    pullQuote:
      '"Revenue grew more than four times from approximately ₹40 crore to ₹170 crore, reflecting rising consumer demand for electric mobility solutions across India."',
    body: [
      "Bengaluru-based electric vehicle startup Simple Energy has raised ₹250 crore in a Series B funding round comprising a mix of equity and debt, as the company accelerates its expansion plans and prepares for a potential IPO in FY28.",
      "The funding round was led by the family office of Thyrocare founder Arokiaswamy Velumani, along with participation from Simple Energy founders Suhas Rajkumar and Ankit Gupta. The debt component of ₹123 crore was provided by HDFC Bank, Capitar Ventures, and other financial institutions.",
      "Founded in 2019, Simple Energy has emerged as one of India's promising electric two-wheeler startups. The company is best known for its premium electric scooters, including the Simple One, which has gained attention for its long-range capabilities and performance-focused design.",
      "The fresh capital will primarily be used to scale manufacturing operations, expand production capacity, strengthen the company's retail footprint, and invest in research and development. According to the company, a significant portion of the funds will support capacity expansion as it targets aggressive growth over the next two years.",
      "Simple Energy currently has a production capacity of around 3,000 electric scooters per month and aims to increase monthly sales to 10,000 units by March 2027. The company has also invested heavily in its battery manufacturing infrastructure, with additional capacity expected to come online in the coming months.",
      "The startup has witnessed strong business momentum over the past year. According to company statements, revenue grew more than four times from approximately ₹40 crore to ₹170 crore, reflecting rising consumer demand for electric mobility solutions across India.",
      "Beyond manufacturing, Simple Energy is rapidly expanding its retail network. The company currently operates through more than 70 outlets across 38 cities and plans to enter several new markets as it strengthens its pan-India presence.",
      "Looking ahead, the company is targeting an initial public offering in the second half of FY28. Management has indicated that a future IPO could help fund further expansion, product development, and new manufacturing facilities as competition intensifies in India's fast-growing electric vehicle market.",
      "With fresh funding, growing revenues, and ambitious expansion plans, Simple Energy is positioning itself as a key player in India's electric two-wheeler ecosystem as the country continues its shift toward sustainable mobility solutions.",
    ],
  },
  {
    id: 3,
    slug: "travel-startup-easemytrip-reports-15-4-crore-q4-fy26-loss-despite-revenue-growth",
    tag: "OPS",
    status: "Draft",
    title:
      "Travel Startup EaseMyTrip Reports ₹15.4 Crore Q4 FY26 Loss Despite Revenue Growth",
    subtitle:
      "Travel startup EaseMyTrip reported a ₹15.4 crore net loss in Q4 FY26 despite revenue growth. Rising expenses and expansion costs impacted profitability as the company focuses on long-term growth.",
    time: "2 Jun",
    published: "2 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/travel-startup-easemytrip-reports-15-4-crore-q4-fy26-loss-despite-revenue-growth.jpg",
    pullQuote:
      '"For the full financial year FY26, EaseMyTrip reported a net loss of ₹47.5 crore compared to a profit in the previous fiscal year."',
    body: [
      "Online travel platform EaseMyTrip reported a net loss of ₹15.4 crore for the fourth quarter of FY26, marking a sharp reversal from the profit it recorded during the same period last year. The company's latest earnings highlight the growing pressure on profitability despite continued growth in revenue.",
      "During the January–March quarter, EaseMyTrip's operating revenue rose by nearly 9% year-on-year to ₹152 crore, driven by steady demand across its travel booking segments. However, higher operating expenses, employee costs and increased investments in business expansion weighed heavily on the company's bottom line.",
      "The Gurugram-based travel startup reported total expenses of over ₹170 crore during the quarter, significantly higher than the previous year. As a result, the company slipped into a loss despite maintaining growth in its core business operations.",
      "For the full financial year FY26, EaseMyTrip reported a net loss of ₹47.5 crore compared to a profit in the previous fiscal year. The results reflect the challenges faced by online travel companies as competition intensifies and customer acquisition costs continue to rise.",
      "Over the past year, EaseMyTrip has actively expanded beyond its core flight booking business through investments, acquisitions, and diversification into adjacent travel segments. The company has also been focusing on international expansion and strengthening its presence across hotels, holidays, and other travel services.",
      "Despite the quarterly setback, management remains optimistic about long-term growth prospects, citing strong travel demand, increasing digital adoption, and opportunities in the broader travel ecosystem. The company expects its diversification strategy to contribute more meaningfully to revenue growth in the coming quarters.",
      "The latest earnings come at a time when India's online travel industry is witnessing rapid evolution, with companies investing aggressively to capture market share. While revenue growth remains healthy, profitability is increasingly becoming a key focus area for investors evaluating travel-tech businesses.",
      "As EaseMyTrip navigates a competitive market environment, the company's ability to balance growth with sustainable profitability will remain closely watched by investors and industry observers alike.",
    ],
  },
  {
    id: 4,
    slug: "wealthtech-startup-scripbox-buys-blue-chip-capital-s-mf-business-in-strategic-expansion-move",
    tag: "DEALS",
    status: "Draft",
    title:
      "WealthTech Startup Scripbox Buys Blue Chip Capital's MF Business in Strategic Expansion Move",
    subtitle:
      "Scripbox is doubling down on growth. The WealthTech startup has acquired Blue Chip Capital's MF business to expand its investor network and strengthen its wealth management capabilities.",
    time: "2 Jun",
    published: "2 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/wealthtech-startup-scripbox-buys-blue-chip-capital-s-mf-business-in-strategic-expansion-move.jpg",
    pullQuote:
      '"Industry experts believe consolidation within the wealth management sector is likely to continue as firms seek scale, operational efficiencies, and stronger customer relationships."',
    body: [
      "WealthTech startup Scripbox has acquired the mutual fund business of Blue Chip Capital, marking another strategic step in its efforts to expand its wealth management footprint and strengthen its position in India's growing investment ecosystem.",
      "The acquisition is expected to strengthen Scripbox's wealth management offerings and expand its presence in the mutual fund distribution business.",
      "Founded in 2012, Scripbox has built a digital-first wealth management platform that offers mutual funds, stocks, fixed-income products, and portfolio advisory services. Over the years, the company has positioned itself as a technology-driven platform focused on helping investors build long-term wealth through simplified investing solutions.",
      "Blue Chip Capital, a well-established investment advisory and mutual fund distribution firm, has served retail and high-net-worth investors for several years. By integrating Blue Chip Capital's mutual fund business into its platform, Scripbox aims to provide existing clients with access to a broader suite of investment products, digital tools, and personalized wealth management services.",
      "The acquisition comes at a time when India's wealth management industry is witnessing rapid growth, driven by increasing retail participation in financial markets, rising awareness of mutual funds, and growing demand for digital investment platforms. WealthTech companies have been actively pursuing acquisitions and partnerships to strengthen market share and accelerate customer acquisition.",
      "For Scripbox, the deal aligns with its long-term strategy of expanding beyond digital investing and building a comprehensive wealth management ecosystem. The company has been steadily enhancing its offerings across financial planning, portfolio management, and investment advisory services to cater to a wider range of investors.",
      "Industry experts believe consolidation within the wealth management sector is likely to continue as firms seek scale, operational efficiencies, and stronger customer relationships. Acquisitions such as this allow digital platforms to rapidly grow their investor base while offering a seamless transition for existing customers.",
      "The acquisition marks another step in Scripbox's efforts to expand its wealth management business in India's WealthTech sector and continue expanding its presence in one of the country's fastest-growing financial services segments.",
    ],
  },
  {
    id: 5,
    slug: "ola-electric-s-ev-registrations-jump-22-in-may-tvs-retains-top-spot",
    tag: "TECH",
    status: "Draft",
    title:
      "Ola Electric's EV Registrations Jump 22% in May, TVS Retains Top Spot",
    subtitle:
      "Ola Electric posted a 22% increase in EV two-wheeler registrations in May, reflecting improving demand, while TVS Motor maintained its lead in India's competitive electric vehicle market.",
    time: "2 Jun",
    published: "2 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/ola-electric-s-ev-registrations-jump-22-in-may-tvs-retains-top-spot.jpg",
    pullQuote:
      '"While startups initially drove the electric scooter revolution, legacy manufacturers such as TVS, Bajaj, and Hero have leveraged their extensive dealer networks, manufacturing capabilities, and brand trust to gain significant market share."',
    body: [
      "India's electric two-wheeler market bounced back strongly in May 2026 after witnessing a slowdown in April, with registrations rising more than 8% month-on-month. Amid the broader market recovery, Ola Electric recorded a 22% increase in registrations, although TVS Motor continued to lead the segment.",
      "Ola Electric registered 15,139 electric two-wheelers in May, up from 12,323 units in April. The increase helped the Bhavish Aggarwal-led company improve its monthly performance after a challenging start to the year. However, Ola remained the fifth-largest player in the electric two-wheeler market with an 8.88% market share.",
      "TVS Motor retained its position as India's leading electric two-wheeler manufacturer in May, registering 42,376 units and capturing a 24.86% market share. Bajaj Auto followed closely with 39,104 registrations and a 22.94% share, continuing to narrow the gap with the market leader.",
      "Ather Energy secured the third spot with 28,190 registrations and a market share of 16.54%, while Hero MotoCorp's electric mobility business recorded 19,044 registrations, accounting for 11.17% of the market.",
      "The latest figures highlight the growing dominance of established automotive companies in India's EV ecosystem. While startups initially drove the electric scooter revolution, legacy manufacturers such as TVS, Bajaj, and Hero have leveraged their extensive dealer networks, manufacturing capabilities, and brand trust to gain significant market share.",
      "For Ola Electric, the growth in May registrations comes as the company focuses on improving customer experience, strengthening service infrastructure, and expanding its product portfolio. The company has faced increased competition over the past year as rivals introduced new electric scooter models and expanded their presence across the country.",
      "Industry experts believe India's electric two-wheeler market is entering a more competitive phase, where factors such as product reliability, after-sales service, financing options, and distribution reach will play a crucial role in determining market leadership.",
      "With EV adoption continuing to accelerate across urban and semi-urban markets, the competition among manufacturers is expected to intensify further in the coming months. While TVS currently leads the market, companies including Bajaj, Ather, Hero, and Ola Electric are all competing aggressively for a larger share of India's fast-growing electric mobility opportunity.",
      "The strong rebound in May registrations signals sustained consumer interest in electric two-wheelers, reinforcing expectations that the segment will remain one of the fastest-growing categories in India's automotive industry.",
    ],
  },
  {
    id: 6,
    slug: "how-zepto-blinkit-and-instamart-are-helping-d2c-brands-win-the-summer-travel-boom",
    tag: "DEEP DIVE",
    status: "Draft",
    title:
      "How Zepto, Blinkit and Instamart Are Helping D2C Brands Win the Summer Travel Boom",
    subtitle:
      "As India's summer travel season gathers pace, D2C brands are leveraging Zepto, Blinkit, and Swiggy Instamart to capture vacation-driven demand, turning the country's growing short-break economy into a new avenue for growth.",
    time: "2 Jun",
    published: "2 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/how-zepto-blinkit-and-instamart-are-helping-d2c-brands-win-the-summer-travel-boom.jpg",
    pullQuote:
      '"Consumers are no longer shopping only for destinations but also for the journey itself — from sunscreen and hydration products to healthy snacks and travel accessories."',
    body: [
      "India's growing summer travel season is emerging as a new consumption opportunity for direct-to-consumer (D2C) brands, with quick-commerce platforms such as Zepto, Blinkit, and Swiggy Instamart becoming key channels for capturing vacation-driven demand.",
      "Traditionally, D2C brands have relied heavily on festive seasons and year-end sales to drive growth. However, changing consumer behavior is creating a new seasonal demand cycle centered around short vacations, weekend getaways, family visits, and summer travel experiences.",
      "Recognising this shift, quick-commerce platforms have introduced dedicated categories and campaigns tailored to travel-related purchases. Platforms such as Blinkit, Zepto, and Instamart are highlighting vacation essentials, travel kits, snacks, personal care products, and family-focused bundles designed for consumers preparing for summer trips.",
      "For D2C brands, the trend presents an opportunity to reach customers at a moment when spending priorities are shifting toward convenience and travel readiness. Brands across categories including skincare, nutrition, packaged foods, beverages, wellness, and personal care are increasingly creating travel-sized products, curated bundles, and seasonal offerings to cater to vacationing consumers.",
      "Industry executives note that consumers are no longer shopping only for destinations but also for the journey itself. From sunscreen and hydration products to healthy snacks and travel accessories, shoppers are increasingly turning to quick-commerce platforms for last-minute purchases before vacations.",
      'The rise of India\'s "short-break economy" is also reshaping marketing strategies. Rather than focusing exclusively on traditional festive periods, brands are now designing campaigns around summer holidays, long weekends, and school vacations. This allows companies to engage consumers during multiple high-intent spending periods throughout the year.',
      "Quick-commerce platforms stand to benefit significantly from the trend. Their promise of delivering products within minutes aligns well with spontaneous travel planning and last-minute shopping needs. As a result, platforms are becoming important discovery channels for emerging D2C brands looking to increase visibility and drive impulse purchases.",
      "The trend highlights the broader evolution of India's consumer economy, where lifestyle-driven spending is creating new opportunities beyond conventional retail seasons. As domestic travel continues to grow and consumers increasingly prioritise experiences, brands are adapting their products, packaging, and marketing efforts to align with changing habits.",
      "For D2C startups, the summer travel season is no longer just a temporary demand spike. It is gradually emerging as a meaningful business opportunity capable of driving customer acquisition, boosting sales, and strengthening brand visibility in an increasingly competitive market.",
      "As India's travel economy expands, the intersection of quick commerce and D2C retail is expected to create new growth avenues, turning summer vacations into one of the most important seasonal opportunities for consumer brands.",
    ],
  },
  {
    id: 7,
    slug: "autotech-unicorn-cars24-commits-20-mn-to-invest-in-early-stage-ai-startups",
    tag: "TECH",
    status: "Draft",
    title:
      "AutoTech Unicorn CARS24 Commits $20 Mn to Invest in Early-Stage AI Startups",
    subtitle:
      "Beyond Cars: AutoTech Unicorn CARS24 has launched CARS24 Labs with a $20 million commitment to invest in early-stage AI startups, support founders, and build AI-first products through strategic partnerships and ecosystem support.",
    time: "2 Jun",
    published: "2 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/autotech-unicorn-cars24-commits-20-mn-to-invest-in-early-stage-ai-startups.jpg",
    pullQuote:
      '"We believe artificial intelligence represents the most significant technological shift of this generation." — Vikram Chopra, Founder & CEO, CARS24',
    body: [
      "Gurugram-based AutoTech unicorn CARS24 has announced a major artificial intelligence push with the launch of CARS24 Labs, a dedicated initiative aimed at building AI-first products, supporting founders and investing in early-stage AI startups. As part of the initiative, the company has committed $20 million (approximately ₹170-190 crore) to startups and teams developing transformative AI technologies.",
      "The move signals CARS24's ambition to expand beyond its core used-car marketplace business. The company said AI has already become deeply embedded across its operations, helping improve decision-making, product development, and customer experiences.",
      "According to the company, CARS24 Labs will operate across three core pillars — Build, Partner and Invest. Under the Build vertical, the company plans to create AI-native products and contribute to open-source innovation. The Partner arm will work with leading AI companies to accelerate experimentation and adoption, while the Invest division will provide capital and strategic support to startups building category-defining AI businesses.",
      "To strengthen the initiative, CARS24 has partnered with industry leaders including OpenAI, Amazon Web Services (AWS) and ElevenLabs. Through these partnerships, startups selected under the program will gain access to capital, infrastructure, mentorship, and access to leading AI technologies.",
      "Speaking about the initiative, CARS24 Founder and CEO Vikram Chopra said the company believes artificial intelligence represents the most significant technological shift of this generation. He added that the goal of CARS24 Labs is to back founders early, help them move faster, and support entrepreneurs building products that could define the future.",
      "Beyond direct investments, CARS24 Labs will also support the broader AI ecosystem through hackathons, builder programs, community initiatives, incubation efforts, and open-source projects aimed at accelerating innovation. The company recently hosted its AI-focused hackathon, Token'26, which attracted more than 1,000 applicants, highlighting growing interest in AI entrepreneurship across India.",
      "The announcement comes as Indian startups and enterprises increasingly race to integrate artificial intelligence into products and operations. With global AI adoption accelerating and investor interest in the sector remaining strong, CARS24 is positioning itself not just as an AI adopter but as a long-term enabler of the next generation of AI companies.",
      "The company is also preparing for a public listing and has been working to improve its financial performance. According to recent disclosures, CARS24 reported strong revenue growth while narrowing its EBITDA losses, as it continues to diversify its business and invest in future technologies.",
      "With CARS24 Labs, the SoftBank-backed startup is making its biggest AI bet yet, aiming to help build a new wave of AI-first startups while strengthening India's position in the global artificial intelligence ecosystem.",
    ],
  },
  {
    id: 8,
    slug: "sportswear-startup-agilitas-raises-225-cr-from-nexus-venture-partners-rainmatter",
    tag: "FUNDING",
    status: "Draft",
    title:
      "Sportswear Startup Agilitas Raises ₹225 Cr from Nexus Venture Partners, Rainmatter",
    subtitle:
      "Bengaluru-based sportswear startup Agilitas has raised ₹225 crore from Nexus Venture Partners and Rainmatter to expand its manufacturing, brand portfolio, and retail presence.",
    time: "3 Jun",
    published: "3 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/sportswear-startup-agilitas-raises-225-cr-from-nexus-venture-partners-rainmatter.png",
    pullQuote:
      '"The fresh capital will be deployed to accelerate growth across our manufacturing, brand and retail verticals," said a company spokesperson.',
    body: [
      "Bengaluru-based sportswear startup Agilitas has raised ₹225 crore from Nexus Venture Partners and Rainmatter to expand its manufacturing, brand portfolio, and retail presence.",
      "Founded by former Puma India Managing Director Abhishek Ganguly along with Atul Bajaj and Amit Prabhu, Agilitas is building an integrated sportswear platform spanning manufacturing, consumer brands and retail.",
      "The fresh capital will be deployed to accelerate growth across these verticals as the company strengthens its position in India's fast-growing sportswear market.",
      "Since its 2023 launch, Agilitas has focused on creating end-to-end capabilities across research, product development, manufacturing, branding, and distribution.",
      "The startup has expanded aggressively through strategic acquisitions and brand partnerships, including the acquisition of Mochiko Shoes and long-term licensing rights for Lotto across India and select international markets.",
      "Agilitas has also been strengthening its consumer-facing business through brands such as Lotto and One8 while investing in retail expansion through SportsYard, its large-format sports retail concept.",
      "The latest investment underscores growing investor confidence in India's sportswear and athleisure market, driven by rising fitness awareness, growing sports participation, and more consumer spending on performance apparel and footwear.",
      "With fresh capital in hand, Agilitas is expected to accelerate product innovation, expand its retail footprint, and deepen its manufacturing capabilities as it pursues its goal of building a homegrown sportswear powerhouse with global ambitions.",
    ],
  },
  {
    id: 9,
    slug: "sap-startup-studio-opens-2026-cohort-for-indias-next-wave-of-ai-startups",
    tag: "PROGRAM",
    status: "Draft",
    title:
      "SAP Startup Studio Opens 2026 Cohort for India’s Next Wave of AI Startups",
    subtitle:
      "SAP Startup Studio has opened applications for its 2026 cohort, inviting AI-first startups to leverage SAP’s technology, enterprise network, and go-to-market ecosystem.",
    time: "3 Jun",
    published: "3 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/sap-startup-studio-opens-2026-cohort-for-indias-next-wave-of-ai-startups.png",
    pullQuote:
      '"We want to help founders build enterprise-grade AI products and scale them globally," said an SAP Startup Studio representative.',
    body: [
      "SAP Startup Studio has opened applications for its 2026 cohort, inviting AI-first startups to leverage SAP’s technology platform, enterprise network, and go-to-market ecosystem.",
      "The six-month accelerator program is designed to support emerging startups working across artificial intelligence and deep-tech domains by providing access to SAP Business Technology Platform credits, technical mentorship, product integration support, and opportunities to collaborate with enterprise customers.",
      "Selected startups will gain access to technical mentorship, product integration support, and opportunities to collaborate with enterprise customers.",
      "The program is focused on startups building solutions in Agentic AI, custom AI agents, enterprise AI, robotics, digital twins, edge intelligence, quantum computing, supply chain technology, finance, human capital management, and cloud ERP.",
      "Through Startup Studio, SAP seeks to bridge the gap between emerging innovation and enterprise adoption by enabling founders to test, validate, and scale their products within real-world business environments.",
      "The initiative comes amid growing interest in AI-driven enterprise solutions as businesses invest in automation, productivity, and intelligent decision-making technologies.",
      "Over the years, SAP has expanded its engagement with the startup ecosystem through accelerator programs, technology partnerships, and innovation initiatives aimed at fostering enterprise-focused entrepreneurship.",
      "Applications for the 2026 cohort are now open, with selected startups expected to participate in a structured program focused on product innovation, enterprise readiness, and go-to-market acceleration.",
    ],
  },
  {
    id: 10,
    slug: "oyo-parent-prism-gets-sebi-approval-for-6650-cr-ipo",
    tag: "IPO",
    status: "Draft",
    title: "OYO Parent PRISM Gets SEBI Approval for ₹6,650 Cr IPO",
    subtitle:
      "OYO parent PRISM has received SEBI approval for its proposed ₹6,650 crore IPO, marking a key milestone as the hospitality unicorn moves closer to a public listing.",
    time: "3 Jun",
    published: "3 June 2026",
    author: "Startup Unplugged",
    cover: "/news/oyo-parent-prism-gets-sebi-approval-for-6650-cr-ipo.png",
    pullQuote:
      '"SEBI clearance is another step in PRISM’s long-awaited journey toward a public listing," said an industry analyst.',
    body: [
      "OYO parent PRISM has received SEBI approval for its proposed ₹6,650 crore IPO, marking a key milestone as the hospitality unicorn moves closer to a public listing.",
      "The regulatory clearance follows the company's confidential draft IPO filing in late 2025 and shareholder approval for the public issue.",
      "PRISM plans to raise ₹6,650 crore through a fresh issue of shares and is expected to file an updated draft red herring prospectus in the coming weeks.",
      "The IPO is likely to value the company between $7 billion and $8 billion, making it one of the most closely watched public listings in India's startup ecosystem.",
      "PRISM, formerly known as Oravel Stays, adopted its new corporate identity in 2025 and operates OYO's hospitality and travel technology platform across hotels, vacation homes, and managed accommodations.",
      "The development comes as OYO continues to strengthen its financial performance and profitability metrics while expanding its global footprint.",
      "SEBI's approval is expected to accelerate PRISM's public market ambitions and provide investors with an opportunity to participate in the next phase of growth for one of India's most prominent startup success stories.",
      "Market participants will be watching the company's next filings and listing timeline closely as PRISM advances toward its long-awaited IPO.",
    ],
  },
  {
    id: 11,
    slug: "d2c-fashion-startup-zouk-set-to-raise-60-cr-in-pre-series-c-funding-round",
    tag: "FUNDING",
    status: "Draft",
    title:
      "D2C Fashion Startup Zouk Set to Raise ₹60 Cr in Pre-Series C Funding Round",
    subtitle:
      "Mumbai-based D2C fashion startup Zouk is set to raise ₹60 crore in a pre-Series C funding round led by Aavishkaar Capital and Stellaris Venture Partners.",
    time: "3 Jun",
    published: "3 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/d2c-fashion-startup-zouk-set-to-raise-60-cr-in-pre-series-c-funding-round.png",
    pullQuote:
      '"The fresh capital will help us deepen our distribution network and support next-stage growth," said a Zouk spokesperson.',
    body: [
      "Mumbai-based D2C fashion startup Zouk is set to raise ₹60 crore in a pre-Series C funding round led by existing investors Aavishkaar Capital and Stellaris Venture Partners.",
      "The company's board has approved issuing 2,468 compulsory convertible cumulative preference shares to raise the fresh capital, with participation from Sharrp Ventures and shareholder Mihir Gadani.",
      "The round is expected to value Zouk at approximately ₹610 crore, marking another milestone in the startup's growth journey.",
      "Founded in 2016 by Disha Singh and Pradeep Krishnakumar, Zouk has built a strong consumer brand around handbags, wallets, backpacks, laptop bags, and travel accessories inspired by Indian designs.",
      "The company has grown through a mix of online marketplaces, its own website, and offline retail channels.",
      "The fresh capital will be used for business expansion, working capital requirements, and general corporate purposes, as Zouk strengthens its distribution and brand presence.",
      "Zouk has emerged as one of India's notable D2C fashion brands, benefiting from increasing consumer demand for homegrown lifestyle and fashion products.",
      "The proposed funding round will support Zouk's expansion plans as it prepares for the next phase of growth.",
    ],
  },
  {
    id: 12,
    slug: "government-backed-ondc-set-to-raise-430-cr-from-sbi-uber-paytm-zoho-and-amul",
    tag: "DEALS",
    status: "Draft",
    title:
      "Government-Backed ONDC Set to Raise ₹430 Cr From SBI, Uber, Paytm, Zoho and Amul",
    subtitle:
      "ONDC is set to raise ₹430 crore from SBI, Zoho, Uber, Paytm, and Amul to support AI-driven commerce initiatives and accelerate growth of its digital commerce network.",
    time: "3 Jun",
    published: "3 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/government-backed-ondc-set-to-raise-430-cr-from-sbi-uber-paytm-zoho-and-amul.png",
    pullQuote:
      '"This funding will help ONDC accelerate its AI commerce initiatives and expand its open network capabilities," said a source close to the deal.',
    body: [
      "ONDC is set to raise ₹430 crore from SBI, Zoho, Uber, Paytm, and Amul to support AI-driven commerce initiatives and accelerate the growth of its digital commerce network.",
      "The proposed round also includes participation from NSE, PNB, BSE Technologies, NAFED, and the Quality Council of India.",
      "ONDC has already secured commitments worth ₹220 crore from several investors, with the remaining capital expected from other institutions and strategic stakeholders.",
      "The fresh funding will primarily support ONDC 2.0 initiatives, including AI-powered commerce solutions, digital public infrastructure projects, and network expansion.",
      "Launched by the Government of India, ONDC aims to democratize digital commerce by enabling buyers and sellers to transact across platforms with reduced marketplace dependency.",
      "The platform reportedly processed over 218 million transactions during FY26, reflecting growing adoption among businesses and consumers.",
      "The latest fundraising highlights broad industry support for ONDC's interoperable digital commerce vision.",
      "With fresh capital, ONDC is expected to accelerate innovation, improve network capabilities, and drive wider adoption across India.",
    ],
  },
  {
    id: 13,
    slug: "insurtech-startup-acko-names-four-new-business-heads-ahead-of-ipo",
    tag: "LEADERSHIP",
    status: "Draft",
    title: "Insurtech Startup Acko Names Four New Business Heads Ahead of IPO",
    subtitle:
      "Acko has appointed four new business heads across key verticals as it strengthens its leadership team and prepares for a planned public listing.",
    time: "3 Jun",
    published: "3 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/insurtech-startup-acko-names-four-new-business-heads-ahead-of-ipo.png",
    pullQuote:
      '"These leadership appointments will help us scale our next phase of growth," said an Acko spokesperson.',
    body: [
      "Insurtech startup Acko has appointed Apoorv Kalra, Kunal Kapur, Vivek Sharma, and Neha Gupta to lead key business functions as the company prepares for a potential IPO.",
      "Apoorv Kalra will head the auto insurance business, while Kunal Kapur will lead the health insurance vertical.",
      "Vivek Sharma will oversee the Acko Drive ecosystem, and Neha Gupta will lead the assisted experience vertical focused on customer engagement and service delivery.",
      "The appointments come as Acko focuses on operational scale and long-term growth ahead of its planned public market debut.",
      "Founded in 2016 by Varun Dua, Acko has emerged as a digital-first insurance platform offering motor, health, travel, and embedded insurance products.",
      "The company has attracted backing from General Atlantic, Accel, Amazon, Multiples, and Elevation Capital.",
      "Acko continues to invest in technology-driven processes, digital distribution, and customer-centric products as it scales across core verticals.",
      "The leadership expansion reflects the company's efforts to strengthen execution ahead of a potential IPO and future growth opportunities.",
    ],
  },
  {
    id: 14,
    slug: "broadband-startup-excitel-turns-profitable-in-fy26-reports-560-cr-revenue",
    tag: "GROWTH",
    status: "Draft",
    title:
      "Broadband Startup Excitel Turns Profitable in FY26, Reports ₹560 Cr Revenue",
    subtitle:
      "Broadband startup Excitel has turned profitable in FY26 while reporting ₹560 crore in revenue, marking a significant milestone in the company's growth journey.",
    time: "3 Jun",
    published: "3 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/broadband-startup-excitel-turns-profitable-in-fy26-reports-560-cr-revenue.png",
    pullQuote:
      '"Profitability combined with revenue growth marks an important milestone for Excitel," said an industry analyst.',
    body: [
      "Broadband startup Excitel turned profitable in FY26 while reporting ₹560 crore in revenue, underscoring its focus on operational efficiency and customer acquisition.",
      "The Gurugram-based ISP operates through a local cable operator partnership model that enables rapid network expansion while keeping costs competitive.",
      "Excitel has expanded its footprint across multiple cities while aiming to improve service reliability and customer experience.",
      "The FY26 performance reflects strong demand for high-speed internet driven by remote work, online education, gaming, and streaming.",
      "The company has focused on competitive pricing and unlimited broadband plans to capture market share in a crowded sector.",
      "Achieving profitability while continuing to grow revenue marks a significant milestone as many growth-stage startups still prioritize expansion over earnings.",
      "Excitel's performance could strengthen its position among independent broadband providers in India's fast-growing internet services market.",
      "The company is expected to focus on expanding its subscriber base, strengthening network infrastructure, and capitalizing on growing demand for broadband services.",
    ],
  },
  {
    id: 15,
    slug: "d2c-perfume-startup-fraganote-raises-3-mn-in-series-a-funding-round",
    tag: "FUNDING",
    status: "Draft",
    title:
      "D2C Perfume Startup Fraganote Raises $3 Mn in Series A Funding Round",
    subtitle:
      "Backed by fresh capital, Fraganote plans to expand beyond perfumes, strengthen brand visibility, and scale its presence in the fragrance and personal care market.",
    time: "3 Jun",
    published: "3 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/d2c-perfume-startup-fraganote-raises-3-mn-in-series-a-funding-round.png",
    pullQuote:
      '"The fresh capital will help us scale our brand and explore adjacent personal care categories," said Fraganote co-founder Shravan Karthikeyan.',
    body: [
      "D2C perfume startup Fraganote has raised $3 million in a Series A funding round to expand beyond perfumes and strengthen its brand visibility.",
      "Founded in 2021 by Shravan Karthikeyan and Aishwarya Karthikeyan, Fraganote has built a premium fragrance brand that caters to evolving consumer preferences.",
      "The fresh capital will be used to accelerate product development, category expansion, and omnichannel presence.",
      "Fraganote plans to deepen its offline retail presence while continuing to expand through direct-to-consumer channels and marketplaces.",
      "India's fragrance market has witnessed strong growth, driven by rising consumer spending on premium personal care products.",
      "The startup is aiming to compete more aggressively in the premium fragrance segment through differentiated products and stronger brand recall.",
      "The investment positions Fraganote to explore adjacent categories within fragrance and personal care.",
      "With fresh funding, the brand is expected to accelerate growth and scale its presence across India.",
    ],
  },
  {
    id: 16,
    slug: "proptech-startup-propsoch-raises-2-mn-expansion-plans-take-center-stage",
    tag: "FUNDING",
    status: "Draft",
    title:
      "PropTech Startup Propsoch Raises $2 Mn; Expansion Plans Take Center Stage",
    subtitle:
      "With a fresh $2 million investment, Propsoch plans to scale its platform, broaden its market reach, and drive innovation in the proptech ecosystem.",
    time: "4 Jun",
    published: "4 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/proptech-startup-propsoch-raises-2-mn-expansion-plans-take-center-stage.webp",
    pullQuote: `"The home-buying journey should be transparent, predictable, and data-driven," said Athera Venture Partners.`,
    body: [
      "Founded by Ashish Acharya and Ravi Agrawal, Propsoch operates a buyer-centric real estate advisory platform designed to help homebuyers make informed property decisions.",
      "The startup focuses on providing independent, data-driven insights across more than 80 parameters, including builder credibility, construction quality, project efficiency, and legal risks.",
      "Propsoch aims to address the lack of transparency in India's residential real estate market through proprietary analytics, expert advisory, and consumer feedback.",
      "The company has already advised more than 1,500 families in Bengaluru and plans to scale its reach while strengthening its presence in Mumbai.",
      "With fresh capital, Propsoch plans to deepen its technology capabilities, expand its advisory network, and solidify its position as a trusted real estate intelligence platform.",
    ],
  },
  {
    id: 17,
    slug: "ola-consumers-worth-shrinks-to-70-mn-as-vanguard-revises-stake-value",
    tag: "OPS",
    status: "Draft",
    title:
      "Ola Consumer’s Worth Shrinks to $70 Mn as Vanguard Revises Stake Value",
    subtitle:
      "Vanguard has marked down Ola Consumer’s valuation to just $70 million, reflecting the continued decline in the ride-hailing company’s consumer business.",
    time: "4 Jun",
    published: "4 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/ola-consumers-worth-shrinks-to-70-mn-as-vanguard-revises-stake-value.webp",
    pullQuote: `"The revised valuation represents a staggering decline of more than 99% from Ola’s peak valuation of $7.3 billion in 2021."`,
    body: [
      "US-based asset management giant Vanguard marked down the company's valuation to approximately $70 million, a decline of more than 99% from its peak of $7.3 billion.",
      "Over the past few years, Vanguard has repeatedly cut the company’s fair value estimates, with the latest assessment marking the steepest decline yet.",
      "Increasing competition from rivals such as Uber and Rapido has significantly impacted Ola's growth and market share in its core ride-hailing business.",
      "Ola Consumer’s operating revenue declined 42% year-on-year to ₹1,171 crore in FY25, while net losses widened, raising questions about its path to profitability.",
      "Persistent valuation cuts and challenging financial performance could complicate the company's reported plans for a public listing.",
    ],
  },
  {
    id: 18,
    slug: "healthy-snacking-startup-phab-raises-4-mn-to-accelerate-growth",
    tag: "FUNDING",
    status: "Draft",
    title: "Healthy Snacking Startup Phab Raises $4 Mn to Accelerate Growth",
    subtitle:
      "Healthy snacking startup Phab has raised $4 million to accelerate growth, expand distribution, and strengthen its product portfolio.",
    time: "4 Jun",
    published: "4 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/healthy-snacking-startup-phab-raises-4-mn-to-accelerate-growth.webp",
    pullQuote: `"The latest funding will help us strengthen our position in the healthy snacking category," said the founders.`,
    body: [
      "Phab has raised $4 million in a fresh funding round led by OTP Ventures, with participation from Capri Global, Sim&San, and several angel investors.",
      "Founded in 2022 by Hocco cofounders, Phab offers a range of protein bars, healthy chocolates, and nutrition-focused snacks.",
      "The startup will use the capital to scale manufacturing, enhance product innovation, and increase its retail and online presence.",
      "The healthy snacking market has witnessed significant growth, driven by increasing health awareness and changing consumer preferences.",
      "Phab has established a presence across major e-commerce platforms, quick-commerce channels, and modern retail stores, building a loyal customer base.",
    ],
  },
  {
    id: 19,
    slug: "fintech-startup-werize-raises-7-mn-to-expand-product-offerings",
    tag: "FUNDING",
    status: "Draft",
    title: "Fintech Startup WeRize Raises $7 Mn to Expand Product Offerings",
    subtitle:
      "Fintech startup WeRize has raised $7 million to expand product offerings and deepen its presence across underserved markets in India.",
    time: "4 Jun",
    published: "4 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/fintech-startup-werize-raises-7-mn-to-expand-product-offerings.webp",
    pullQuote: `"We aim to become a comprehensive financial services platform for millions of consumers seeking accessible and affordable financial solutions."`,
    body: [
      "WeRize has raised $7 million in a funding round led by existing investors to enhance its technology and launch new financial products.",
      "Founded in 2019, the startup operates a full-stack platform focused on serving middle-income customers in tier II, tier III, and rural markets.",
      "The company combines technology with a network of community-based financial advisors to provide access to credit, insurance, and other financial products.",
      "The fresh capital will support the development of additional lending, insurance, and wealth management offerings.",
      "WeRize's latest fundraise underscores the growing importance of startups focused on financial inclusion across Bharat's emerging markets.",
    ],
  },
  {
    id: 20,
    slug: "ai-startup-truefan-raises-fresh-capital-for-international-growth",
    tag: "FUNDING",
    status: "Draft",
    title: "AI Startup TrueFan Raises Fresh Capital for International Growth",
    subtitle:
      "AI startup TrueFan has raised $10 million in fresh funding to fuel its international expansion and enter new markets.",
    time: "4 Jun",
    published: "4 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/ai-startup-truefan-raises-fresh-capital-for-international-growth.webp",
    pullQuote: `"This funding will support our efforts to scale operations and enhance our AI-powered fan engagement platform globally," said the company.`,
    body: [
      "AI-powered fan engagement startup TrueFan has raised $10 million to accelerate international expansion and strengthen its presence across new markets.",
      "The startup leverages AI and data analytics to deliver personalized fan experiences for brands, creators, and sports organizations.",
      "The fresh capital will be used to expand into new international markets, strengthen product development, and scale its AI capabilities.",
      "Fan engagement technologies are in growing demand as businesses compete for audience attention in sports, entertainment, and the creator economy.",
      "TrueFan's latest fundraise marks a significant milestone in its journey to become a leading global player in AI-powered audience engagement solutions.",
    ],
  },
  {
    id: 21,
    slug: "ideabaaz-startup-fest-2026-announces-mega-startup-gathering-at-bharat-mandapam",
    tag: "EVENT",
    status: "Draft",
    title:
      "Ideabaaz Startup Fest 2026 Announces Mega Startup Gathering at Bharat Mandapam",
    subtitle:
      "From startup pitches to investor meetings, Ideabaaz Startup Fest 2026 promises to bring together the brightest founders and leading investors at Bharat Mandapam this August.",
    time: "6 Jun",
    published: "6 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/ideabaaz-startup-fest-2026-announces-mega-startup-gathering-at-bharat-mandapam.webp",
    pullQuote: `"This festival will create unparalleled opportunities for startups to connect with investors and mentors," said the organizers.`,
    body: [
      "Ideabaaz Startup Fest 2026 is set to take place at Bharat Mandapam, New Delhi, from August 26 to 30, featuring more than 300 startups and over 150 investors.",
      "The five-day event will offer startup exhibitions, investor interactions, founder meetups, workshops, and live pitch opportunities.",
      "With a strong lineup of venture capital firms, angel investors, and family offices, the festival aims to provide founders with access to potential funding and strategic guidance.",
      "The event builds on the growing visibility of the Ideabaaz brand, which has expanded from a television format to a broader entrepreneurship platform.",
      "As India's startup ecosystem continues to thrive, such events have become crucial meeting grounds for accessing capital, mentorship, and market opportunities.",
    ],
  },
  {
    id: 22,
    slug: "gurgaon-startup-aims-to-benefit-from-haryana-expanding-avgc-sector",
    tag: "ECOSYSTEM",
    status: "Draft",
    title:
      "Gurgaon Startup Aims to Benefit From Haryana’s Expanding AVGC Sector",
    subtitle:
      "As Haryana pushes to strengthen its animation and gaming ecosystem, a Gurgaon startup is looking to leverage the momentum in the creative technology sector.",
    time: "6 Jun",
    published: "6 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/gurgaon-startup-aims-to-benefit-from-haryana-expanding-avgc-sector.webp",
    pullQuote: `"Rising demand for digital entertainment and gaming is creating new avenues for innovation and business growth."`,
    body: [
      "A Gurgaon-based startup is positioning itself to capitalize on Haryana's growing focus on the Animation, Visual Effects, Gaming, and Comics (AVGC) sector.",
      "The AVGC industry has gained significant attention in India, driven by advancements in technology, wider internet access, and increasing smartphone adoption.",
      "Gurgaon offers a strong foundation for digital-first industries with its large talent pool, established infrastructure, and thriving entrepreneurial ecosystem.",
      "State-level support, including incubation programs and industry partnerships, can play a vital role in helping AVGC startups scale their operations.",
      "As Haryana expands its focus on creative and technology-driven industries, startups are looking to contribute to the region's innovation economy.",
    ],
  },
  {
    id: 23,
    slug: "anand-mahindra-on-indias-startup-future-you-aint-seen-nothing-yet",
    tag: "OPINION",
    status: "Draft",
    title:
      "‘You Ain’t Seen Nothing Yet’: Anand Mahindra on India’s Startup Future",
    subtitle:
      "Mahindra Group Chairman Anand Mahindra has forecast a significant surge in entrepreneurial activity, arguing that India’s startup ecosystem has only scratched the surface of its potential.",
    time: "6 Jun",
    published: "6 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/anand-mahindra-on-indias-startup-future-you-aint-seen-nothing-yet.webp",
    pullQuote: `"India’s startup boom has only just begun, and the world has yet to see its full potential."`,
    body: [
      "Anand Mahindra expressed strong optimism about India's entrepreneurial future, suggesting the country is in the early stages of a much larger growth wave.",
      "His comments came in response to a study showing that Indian-born entrepreneurs are the largest contributors to US-based unicorn startups among immigrant founders.",
      "While acknowledging the success of Indians abroad, Mahindra argued that the next major chapter of innovation will unfold within India itself.",
      "India has already established itself as one of the world's largest startup ecosystems, driven by internet penetration, digital infrastructure, and growing investor participation.",
      "His message reflects a growing belief that India's next generation of startups will not only serve the domestic market but also build globally competitive products and technologies.",
    ],
  },
  {
    id: 24,
    slug: "ai-startup-lumiq-set-to-raise-50-cr-in-series-b-round-led-by-bajaj-finserv-and-info-edge",
    tag: "FUNDING",
    status: "Draft",
    title:
      "AI Startup Lumiq Set to Raise ₹50 Cr in Series B Round Led by Bajaj Finserv and Info Edge",
    subtitle:
      "Bajaj Finserv and Info Edge are set to back Lumiq's ₹50 crore Series B round, providing fresh momentum to the AI startup's expansion in the financial services industry.",
    time: "6 Jun",
    published: "6 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/ai-startup-lumiq-set-to-raise-50-cr-in-series-b-round-led-by-bajaj-finserv-and-info-edge.webp",
    pullQuote: `"The new capital will support product innovation, talent expansion, and broader market growth initiatives."`,
    body: [
      "AI and data platform Lumiq is set to raise ₹50 crore in a Series B round, with Bajaj Finserv Ventures expected to lead the investment.",
      "Founded in Noida, Lumiq develops AI-powered data and analytics solutions for banks, insurers, and other financial institutions.",
      "The funding comes as demand for AI-led enterprise software continues to rise across the banking, financial services, and insurance (BFSI) sector.",
      "Lumiq has positioned itself as a specialist in the BFSI segment, offering products designed for financial enterprises' data transformation and AI needs.",
      "The investment reflects growing confidence in startups operating at the intersection of AI, enterprise software, and financial technology.",
    ],
  },
  {
    id: 25,
    slug: "startup-policy-forum-recommends-simpler-kyc-rules-for-overseas-indian-investors",
    tag: "POLICY",
    status: "Draft",
    title:
      "Startup Policy Forum Recommends Simpler KYC Rules for Overseas Indian Investors",
    subtitle:
      "Startup Policy Forum has urged policymakers to simplify KYC rules for NRIs, arguing that easier verification could drive more overseas investment into India's startup ecosystem.",
    time: "6 Jun",
    published: "6 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/startup-policy-forum-recommends-simpler-kyc-rules-for-overseas-indian-investors.webp",
    pullQuote: `"Streamlined KYC procedures could unlock significant additional investment flows from the Indian diaspora."`,
    body: [
      "Startup Policy Forum (SPF) has called for reforms to simplify Know Your Customer (KYC) requirements for Non-Resident Indians (NRIs) seeking to invest in India.",
      "The industry body argues that many NRIs face operational challenges with digital onboarding and verification, slowing down investment.",
      "Key proposals include easing restrictions on video-based KYC and improving interoperability between different regulatory systems.",
      "The recommendations come as regulators explore ways to increase NRI participation in India's capital markets.",
      "Easier onboarding could play a crucial role in strengthening participation from the diaspora across India's financial and startup ecosystems.",
    ],
  },
  {
    id: 26,
    slug: "inside-cellogen-the-biotech-startup-trying-to-make-500k-cancer-care-affordable",
    tag: "DEEP DIVE",
    status: "Draft",
    title:
      "Inside Cellogen, The Biotech Startup Trying To Make $500K Cancer Care Affordable",
    subtitle:
      "Biotech startup Cellogen is working to lower the barriers to advanced cancer treatment by developing affordable and scalable solutions for cutting-edge therapies.",
    time: "6 Jun",
    published: "6 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/inside-cellogen-the-biotech-startup-trying-to-make-500k-cancer-care-affordable.webp",
    pullQuote: `"Our goal is not only to develop breakthrough treatments but also to ensure that more patients can benefit from them."`,
    body: [
      "Cellogen is focused on developing affordable cell and gene therapy solutions to make advanced cancer care more accessible.",
      "Some next-generation cancer treatments can cost hundreds of thousands of dollars, putting them beyond the reach of most patients.",
      "The startup believes that localized research, manufacturing, and innovation can play a key role in lowering these cost barriers.",
      "Cellogen's efforts come at a time when India's biotechnology sector is gaining momentum, with increasing investment and a growing pool of scientific talent.",
      "If successful, the company could help make advanced cancer therapies accessible to a broader segment of patients who currently face significant financial barriers.",
    ],
  },
  {
    id: 27,
    slug: "ai-startup-emergent-appoints-together-fund-manav-garg-as-executive-chairman",
    tag: "LEADERSHIP",
    status: "Draft",
    title:
      "AI Startup Emergent Appoints Together Fund’s Manav Garg as Executive Chairman",
    subtitle:
      "Emergent has appointed Together Fund co-founder and veteran SaaS entrepreneur Manav Garg as its Executive Chairman to strengthen the company's leadership and accelerate growth.",
    time: "5 Jun",
    published: "5 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/ai-startup-emergent-appoints-together-fund-manav-garg-as-executive-chairman.webp",
    pullQuote: `"Manav's experience will be invaluable as we scale our AI platform and expand our enterprise offerings," said the founders.`,
    body: [
      "AI startup Emergent has appointed Together Fund cofounder and managing partner Manav Garg as its Executive Chairman.",
      "Garg will work with Emergent’s founders on strategy, governance, partnerships, and business growth, marking his return to a more active operating role.",
      "Founded in 2024, Emergent develops AI-powered software that enables users to build applications through natural language prompts in the 'vibe coding' segment.",
      "The startup is backed by prominent investors including Together Fund, SoftBank Vision Fund, Khosla Ventures, Prosus, Lightspeed Venture Partners, and Y Combinator.",
      "Garg's background in building and scaling enterprise software companies is expected to help Emergent strengthen its market position as AI competition intensifies.",
    ],
  },
  {
    id: 28,
    slug: "peak-xv-partners-sells-go-digit-shares-worth-100-cr-amid-portfolio-rebalancing",
    tag: "DEALS",
    status: "Draft",
    title:
      "Peak XV Partners Sells Go Digit Shares Worth ₹100 Cr Amid Portfolio Rebalancing",
    subtitle:
      "Venture capital firm Peak XV Partners has sold Go Digit shares worth ₹100 crore as it continues to rebalance holdings following the insurer's public market debut.",
    time: "5 Jun",
    published: "5 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/peak-xv-partners-sells-go-digit-shares-worth-100-cr-amid-portfolio-rebalancing.webp",
    pullQuote: `"The transaction is part of a broader trend where venture capital firms are unlocking value through public markets."`,
    body: [
      "Peak XV Partners has sold Go Digit shares worth approximately ₹100 crore through a block deal, marking another significant liquidity event for the firm.",
      "The share sale comes as Peak XV, formerly Sequoia Capital India & Southeast Asia, continues to monetise investments in its publicly listed portfolio companies.",
      "Following the transaction, Go Digit's stock witnessed strong buying activity, with shares gaining nearly 9% in subsequent trading sessions.",
      "Peak XV was an early supporter of Go Digit, which has emerged as one of India's leading digital-first insurers.",
      "The move highlights a broader trend of venture capital firms realizing returns through public markets after supporting startups through their growth phases.",
    ],
  },
  {
    id: 29,
    slug: "vietnam-green-sm-enters-india-to-accelerate-ev-mobility-push",
    tag: "MOBILITY",
    status: "Draft",
    title: "Vietnam’s Green SM Enters India to Accelerate EV Mobility Push",
    subtitle:
      "Green SM, the electric ride-hailing platform backed by Vietnamese EV maker VinFast, has entered India, strengthening competition in the EV mobility sector.",
    time: "5 Jun",
    published: "5 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/vietnam-green-sm-enters-india-to-accelerate-ev-mobility-push.webp",
    pullQuote: `"Our fully electric fleet and service-focused model will help us carve out a meaningful share of the market," said a Green SM spokesperson.`,
    body: [
      "Vietnam-based electric mobility company Green SM has launched its ride-hailing operations in the Delhi-NCR region, with plans to expand to other major cities.",
      "The company, part of the ecosystem backed by Vingroup and VinFast, operates an all-electric taxi fleet and is expanding internationally.",
      "Green SM plans to deploy around 10,000 electric vehicles in the region, highlighting its long-term commitment to India's EV mobility landscape.",
      "Unlike competitors, Green SM follows an asset-owned model, operating its own fleet to maintain control over service quality and customer experience.",
      "The launch aligns with VinFast's broader ambitions in India, which include vehicle manufacturing, infrastructure, and mobility services.",
    ],
  },
  {
    id: 30,
    slug: "quick-commerce-unicorn-zepto-responds-to-parimatch-investigation-reports",
    tag: "LEGAL",
    status: "Draft",
    title:
      "Quick Commerce Unicorn Zepto Responds to Parimatch Investigation Reports",
    subtitle:
      "Quick commerce startup Zepto has responded to reports linking the company to the Enforcement Directorate's investigation into Parimatch, stating the claims are inaccurate.",
    time: "5 Jun",
    published: "5 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/quick-commerce-unicorn-zepto-responds-to-parimatch-investigation-reports.webp",
    pullQuote: `"We have fully cooperated with authorities and have no operational role in the matter," Zepto stated.`,
    body: [
      "Zepto issued a clarification after media reports suggested a link to the Enforcement Directorate's (ED) investigation into offshore betting platform Parimatch.",
      "The company emphasized that its involvement was limited and that it was not associated with the betting platform's business activities.",
      "Zepto stated it had responded to all queries from authorities and provided the required information, reiterating its commitment to compliance.",
      "The development comes as regulatory agencies increase scrutiny of offshore betting and gaming platforms operating in India.",
      "Zepto's clarification aims to distance the company from the ongoing probe as it continues to compete in India's fast-growing quick commerce market.",
    ],
  },
  {
    id: 31,
    slug: "ai-powered-cybersecurity-startup-innefu-labs-secures-30-mn-funding-led-by-panthera-growth-partners",
    tag: "FUNDING",
    status: "Draft",
    title:
      "AI-Powered Cybersecurity Startup Innefu Labs Secures $30 Mn Funding Led by Panthera Growth Partners",
    subtitle:
      "Cybersecurity startup Innefu Labs has raised $30 million from Panthera Growth Partners to strengthen its AI-driven solutions and expand globally.",
    time: "5 Jun",
    published: "5 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/ai-powered-cybersecurity-startup-innefu-labs-secures-30-mn-funding-led-by-panthera-growth-partners.webp",
    pullQuote: `"The new capital will accelerate our product development and support our international growth initiatives," said the company.`,
    body: [
      "Innefu Labs has secured $30 million in fresh funding from Panthera Growth Partners, marking a notable investment in India's deep-tech ecosystem.",
      "Founded in 2010 by Tarun Wig, the startup develops AI-powered cybersecurity, intelligence, and data analytics solutions for enterprises and government agencies.",
      "The funding comes as cyber threats grow more sophisticated, prompting increased investment in advanced security technologies worldwide.",
      "Innefu Labs will use the capital to strengthen R&D, expand product capabilities, and support international growth and talent acquisition.",
      "The investment highlights increasing investor interest in India's deep-tech sector, particularly in startups focused on AI and cybersecurity.",
    ],
  },
  {
    id: 32,
    slug: "ola-consumer-growth-story-faces-its-biggest-test-yet",
    tag: "DEEP DIVE",
    status: "Draft",
    title: "Ola Consumer’s Growth Story Faces Its Biggest Test Yet",
    subtitle:
      "Ola Consumer is under pressure to revive momentum amid rising competition and evolving market conditions as industry stakeholders closely track its growth strategy.",
    time: "7 Jun",
    published: "7 June 2026",
    author: "Startup Unplugged",
    cover: "/news/ola-consumer-growth-story-faces-its-biggest-test-yet.webp",
    pullQuote: `"Ola's core ride-hailing business lost momentum during a period when competition was intensifying," critics argue.`,
    body: [
      "Once India's dominant ride-hailing platform, Ola Consumer now faces declining revenues, rising losses, and shrinking market share.",
      "Global investment giant Vanguard marked down the company's valuation significantly, reigniting questions about its future and ability to regain relevance.",
      "ANI Technologies, Ola's parent, reported a sharp decline in operating revenue in FY25, with losses widening and cash reserves reducing.",
      "Critics argue that founder Bhavish Aggarwal's shift in focus to Ola Electric and Krutrim allowed competitors like Uber and Rapido to strengthen their positions.",
      "As competition intensifies, Ola Consumer faces a critical period that will determine whether it can reclaim its position in India's mobility sector.",
    ],
  },
  {
    id: 33,
    slug: "up-cm-yogi-adityanath-calls-for-stronger-startup-ecosystem-centered-on-ai-and-deep-tech",
    tag: "POLICY",
    status: "Draft",
    title:
      "UP CM Yogi Adityanath Calls for Stronger Startup Ecosystem Centered on AI and Deep-Tech",
    subtitle:
      "Yogi Adityanath has directed officials to strengthen the Startup Mission with a focus on AI and deep-tech to boost innovation and growth in Uttar Pradesh.",
    time: "7 Jun",
    published: "7 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/up-cm-yogi-adityanath-calls-for-stronger-startup-ecosystem-centered-on-ai-and-deep-tech.webp",
    pullQuote: `"States that successfully build capabilities in AI and deep-tech will be better positioned to attract investments and create high-value jobs," said the Chief Minister.`,
    body: [
      "Uttar Pradesh Chief Minister Yogi Adityanath has called for strengthening the state's Startup Mission with a focus on AI, deep-tech, robotics, and machine learning.",
      "He emphasized creating a robust ecosystem that supports innovation, attracts investment, and generates employment opportunities for young entrepreneurs.",
      "The Uttar Pradesh Startup Policy is a key pillar of the state's economic strategy, with the government promoting entrepreneurship through incubators, funding, and mentorship.",
      "The Chief Minister stressed connecting educational institutions with the startup ecosystem to foster innovation and help students transform ideas into businesses.",
      "This focus on emerging technologies aligns with national efforts and is expected to attract a new generation of startups, driving long-term economic growth.",
    ],
  },
  {
    id: 34,
    slug: "travel-startup-bliink-targets-southeast-asia-sme-business-travel-market",
    tag: "TRAVEL",
    status: "Draft",
    title:
      "Travel Startup Bliink Targets Southeast Asia’s SME Business Travel Market",
    subtitle:
      "Traveltech startup Bliink is targeting Southeast Asia’s SME business travel market with solutions designed to simplify corporate travel management.",
    time: "7 Jun",
    published: "7 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/travel-startup-bliink-targets-southeast-asia-sme-business-travel-market.webp",
    pullQuote: `"We are digitizing workflows to provide businesses with enterprise-grade travel management tools without the complexity," said Bliink's founders.`,
    body: [
      "Business travel startup Bliink is focusing on Southeast Asia’s SME market, aiming to simplify corporate travel with AI and concierge-driven services.",
      "The company addresses the challenge SMEs face in managing business travel efficiently without the resources available to large enterprises.",
      "Bliink combines AI-powered travel management with human support, enabling organizations to book travel while maintaining oversight of policies and budgets.",
      "Southeast Asia is an attractive market, with millions of SMEs and increasing demand for sophisticated travel management solutions as digital adoption grows.",
      "By focusing on technology, automation, and SME-specific requirements, Bliink is positioning itself to serve the growing demand for digital corporate travel solutions in the region.",
    ],
  },
  {
    id: 35,
    slug: "startup-curefoods-joins-list-of-firms-delaying-ipos-due-to-market-turbulence",
    tag: "IPO",
    status: "Draft",
    title:
      "Startup Curefoods Joins List of Firms Delaying IPOs Due to Market Turbulence",
    subtitle:
      "Startup Curefoods has reportedly delayed its IPO plans amid continued market volatility, expected to wait for a more favorable market environment.",
    time: "8 Jun",
    published: "8 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/startup-curefoods-joins-list-of-firms-delaying-ipos-due-to-market-turbulence.webp",
    pullQuote: `"Market volatility and uncertainty around investor demand have encouraged many firms to prioritize timing over speed," industry observers noted.`,
    body: [
      "Foodtech startup Curefoods has put its initial public offering (IPO) plans on hold despite securing approval from the Securities and Exchange Board of India (SEBI).",
      "The Bengaluru-based company decided to delay its debut amid uncertain market conditions and fluctuating investor sentiment.",
      "Founded in 2020 by Ankit Nagori, Curefoods operates multiple food and beverage brands across cloud kitchens, QSRs, and offline dining formats.",
      "The decision reflects a broader trend of venture-backed companies becoming cautious about entering public markets, prioritizing timing and better valuation outcomes.",
      "Curefoods' delay underscores how well-prepared startups with regulatory approvals are willing to wait for stronger investor participation and long-term value creation.",
    ],
  },
  {
    id: 36,
    slug: "biotech-startup-immuneel-therapeutics-raises-over-100-cr-in-series-b-funding-round",
    tag: "FUNDING",
    status: "Draft",
    title:
      "Biotech Startup Immuneel Therapeutics Raises Over ₹100 Cr in Series B Funding Round",
    subtitle:
      "Cancer-focused biotech startup Immuneel Therapeutics has raised over ₹100 crore to enhance manufacturing, drive research, and make advanced therapies accessible.",
    time: "8 Jun",
    published: "8 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/biotech-startup-immuneel-therapeutics-raises-over-100-cr-in-series-b-funding-round.webp",
    pullQuote: `"The fresh capital will accelerate product development, strengthen manufacturing infrastructure, and improve access to innovative cancer therapies," said the company.`,
    body: [
      "Immuneel Therapeutics has raised over ₹100 crore in a Series B funding round with participation from Singularity AMC, Rainmatter, and strategic backers.",
      "Co-founded by Biocon founder Kiran Mazumdar-Shaw, the startup focuses on developing and commercializing cell and gene therapies, including CAR-T cell therapies.",
      "The capital will be used to expand manufacturing capabilities, improve treatment affordability, and support international market expansion.",
      "The investment reflects growing interest in India's biotechnology sector, particularly in precision medicine, immunotherapy, and next-generation healthcare technologies.",
      "Immuneel's successful fundraise highlights growing confidence in India's biotech innovation landscape to bring globally competitive healthcare solutions to market.",
    ],
  },
  {
    id: 37,
    slug: "ai-startup-physicsx-reaches-2-4-billion-valuation-to-expand-manufacturing-solutions",
    tag: "FUNDING",
    status: "Draft",
    title:
      "AI Startup PhysicsX Reaches $2.4 Billion Valuation to Expand Manufacturing Solutions",
    subtitle:
      "Manufacturing AI startup PhysicsX has secured fresh capital at a $2.4 billion valuation to expand its AI-powered engineering platform globally.",
    time: "8 Jun",
    published: "8 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/ai-startup-physicsx-reaches-2-4-billion-valuation-to-expand-manufacturing-solutions.webp",
    pullQuote: `"The next major wave of value creation could emerge from AI-powered platforms that transform engineering, manufacturing, and scientific workflows," industry experts suggest.`,
    body: [
      "Manufacturing-focused AI startup PhysicsX has reached a valuation of $2.4 billion following a major funding round.",
      "The London-based company develops AI-powered software for engineering and manufacturing businesses to design, test, and optimize products more efficiently.",
      "Unlike consumer AI, PhysicsX specializes in industrial use cases in aerospace, automotive, energy, and advanced manufacturing.",
      "The fresh funding comes as industrial companies increasingly explore AI-driven solutions to improve productivity, reduce costs, and enhance innovation.",
      "PhysicsX's $2.4 billion valuation demonstrates the growing belief that specialized AI platforms will play a central role in shaping the future of manufacturing.",
    ],
  },
  {
    id: 38,
    slug: "workspace-startup-incuspaze-acquires-ikeva-to-expand-managed-workspace-network",
    tag: "DEALS",
    status: "Draft",
    title:
      "Workspace Startup Incuspaze Acquires iKeva to Expand Managed Workspace Network",
    subtitle:
      "Workspace startup Incuspaze has acquired iKeva to accelerate expansion and capture a larger share of India's fast-growing flexible office market.",
    time: "8 Jun",
    published: "8 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/workspace-startup-incuspaze-acquires-ikeva-to-expand-managed-workspace-network.webp",
    pullQuote: `"Consolidation provides a faster route to scale while enabling companies to strengthen occupancy levels and improve profitability," industry experts believe.`,
    body: [
      "Managed workspace provider Incuspaze has acquired Hyderabad-based coworking operator iKeva to accelerate expansion across India.",
      "The acquisition is expected to add nearly ₹100 crore in annual revenue and significantly strengthen Incuspaze's footprint in southern markets.",
      "Founded in 2016, Incuspaze operates across multiple cities with a portfolio exceeding 4 million square feet, offering coworking and enterprise workspace solutions.",
      "The move aligns with consolidation trends in the coworking sector, driven by demand from enterprises, startups, and Global Capability Centres (GCCs).",
      "With iKeva joining its portfolio, Incuspaze takes another step toward becoming one of India's largest integrated workspace platforms.",
    ],
  },
  {
    id: 39,
    slug: "zepto-moves-ahead-with-ipo-nexus-to-offload-majority-ofs-stake",
    tag: "IPO",
    status: "Draft",
    title: "Zepto Moves Ahead With IPO, Nexus to Offload Majority OFS Stake",
    subtitle:
      "Quick commerce startup Zepto has filed updated IPO papers with SEBI, proposing a ₹8,010 crore fresh issue.",
    time: "9 Jun",
    published: "9 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/zepto-moves-ahead-with-ipo-nexus-to-offload-majority-ofs-stake.webp",
    pullQuote: `"The filing marks a major milestone in Zepto's IPO journey as it prepares for a closely watched public listing," industry sources stated.`,
    body: [
      "Quick commerce unicorn Zepto has filed its Updated Draft Red Herring Prospectus (UDRHP) with SEBI.",
      "The proposed IPO includes a fresh issue of ₹8,010 Cr and an Offer for Sale (OFS), bringing the total issue size to around ₹10,000 Cr.",
      "Early backer Nexus Venture Partners will account for nearly 77% of the OFS component.",
      "Zepto plans to deploy the fresh capital toward expanding its dark store network and strengthening technology and cloud infrastructure.",
      "The company is looking to become the first pure-play quick commerce startup to list on Indian stock exchanges.",
    ],
  },
  {
    id: 40,
    slug: "zepto-doubles-revenue-but-burns-more-cash-fy26-loss-hits-5905-cr",
    tag: "FINANCE",
    status: "Draft",
    title:
      "Zepto Doubles Revenue but Burns More Cash, FY26 Loss Hits ₹5,905 Cr",
    subtitle:
      "Zepto doubled its revenue in FY26, but higher spending pushed its annual loss to ₹5,905 Cr amid aggressive expansion.",
    time: "9 Jun",
    published: "9 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/zepto-doubles-revenue-but-burns-more-cash-fy26-loss-hits-5905-cr.webp",
    pullQuote: `"The sharp revenue growth underscores the rapid expansion of India's quick commerce market," financial reports indicated.`,
    body: [
      "Quick commerce startup Zepto more than doubled its revenue in FY26 to ₹22,624 Cr, driven by higher order volumes.",
      "However, the startup's net loss increased to ₹5,905 Cr during the year as expenses rose alongside its rapid scale-up efforts.",
      "Zepto has been aggressively investing in infrastructure, technology, and customer acquisition to strengthen its market position.",
      "The financial performance comes as the company prepares for its public market debut, recently filing its UDRHP with SEBI.",
      "Investors will closely watch whether Zepto can sustain growth while improving operating efficiencies and moving toward profitability.",
    ],
  },
  {
    id: 41,
    slug: "indias-next-startup-wave-will-be-built-on-specialisation",
    tag: "TRENDS",
    status: "Draft",
    title: "India's Next Startup Wave Will Be Built on Specialisation",
    subtitle:
      "From deeptech to agritech, Indian startups are increasingly choosing depth over scale as vertical specialisation gains momentum.",
    time: "9 Jun",
    published: "9 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/indias-next-startup-wave-will-be-built-on-specialisation.webp",
    pullQuote: `"The next decade may be defined by globally competitive companies built on deep technology, specialised expertise, and long-term innovation."`,
    body: [
      "India's startup ecosystem is transitioning from broad consumer platforms to specialized, industry-specific solutions.",
      "Founders are targeting complex problems requiring deep domain expertise in sectors like semiconductors, deeptech, agritech, and AI.",
      "Government initiatives and global supply chain realignments have encouraged innovation in these strategic sectors.",
      "Vertical startups create stronger competitive advantages through intellectual property, proprietary datasets, and industry expertise.",
      "The rise of sector-focused startups reflects the growing maturity of India's innovation ecosystem.",
    ],
  },
  {
    id: 42,
    slug: "peak-xv-leads-72-cr-round-in-quick-commerce-startup-bazaarnow",
    tag: "FUNDING",
    status: "Draft",
    title: "Peak XV Leads ₹72 Cr Round in Quick Commerce Startup BazaarNow",
    subtitle:
      "Quick commerce startup BazaarNow has raised ₹72 Cr in a funding round led by Peak XV Partners to scale its operations.",
    time: "9 Jun",
    published: "9 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/peak-xv-leads-72-cr-round-in-quick-commerce-startup-bazaarnow.webp",
    pullQuote: `"BazaarNow's focus on regional consumers and underserved markets aims to carve out a distinct position in the crowded segment."`,
    body: [
      "BazaarNow raised ₹72 Cr in a round led by Peak XV Partners, with participation from Whiteboard Capital, Antler, and angel investors.",
      "Founded in 2026 by former Zepto executives, BazaarNow focuses on middle-class households in tier II and tier III cities.",
      "The platform adopts a vernacular-first approach, combining AI-powered local-language search and an in-house logistics stack.",
      "BazaarNow will use the capital to expand into nearby towns, strengthen its supply chain, and enhance its local-language user experience.",
      "The funding highlights continued investor interest in India's highly competitive quick commerce sector.",
    ],
  },
  {
    id: 43,
    slug: "wedding-planning-startup-the-wedding-company-bags-2-8-mn-in-fresh-funding",
    tag: "FUNDING",
    status: "Draft",
    title:
      "Wedding Planning Startup The Wedding Company Bags $2.8 Mn in Fresh Funding",
    subtitle:
      "The Wedding Company has raised $2.75 Mn in seed funding to expand its vendor network and strengthen its wedding services portfolio.",
    time: "9 Jun",
    published: "9 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/wedding-planning-startup-the-wedding-company-bags-2-8-mn-in-fresh-funding.webp",
    pullQuote: `"The Wedding Company aims to simplify the traditionally fragmented and unorganised wedding planning process," the founders noted.`,
    body: [
      "Wedding planning startup The Wedding Company raised $2.75 Mn in a seed round led by Wellingdon Advisors.",
      "The capital will be used to expand the vendor partner network, build a stronger category management function, and enhance service offerings.",
      "The startup operates a tech-enabled platform helping couples plan and execute weddings across venues, décor, catering, and logistics.",
      "Targeting India's $130 Bn wedding industry, the company expects to execute 1,500 weddings this financial year.",
      "The funding reflects ongoing opportunities in bringing structure and transparency to traditionally offline consumer service markets.",
    ],
  },
  {
    id: 44,
    slug: "ev-charging-startup-exponent-energy-raises-200-cr-in-series-b2-round-led-by-360-one-asset-tdk-ventures",
    tag: "FUNDING",
    status: "Draft",
    title:
      "EV Charging Startup Exponent Energy Raises ₹200 Cr in Series B2 Round Led By 360 ONE Asset, TDK Ventures",
    subtitle:
      "Fresh capital of ₹200 crore will help Exponent Energy scale its rapid-charging network as demand for electric mobility continues to rise in India.",
    time: "10 Jun",
    published: "10 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/ev-charging-startup-exponent-energy-raises-200-cr-in-series-b2-round-led-by-360-one-asset-tdk-ventures.webp",
    pullQuote: `"The fresh capital will be used to strengthen Exponent Energy’s charging network, expand into new markets, and support the growing adoption of electric commercial vehicles."`,
    body: [
      "EV charging startup Exponent Energy has raised ₹200 crore in a Series B2 funding round led by 360 ONE Asset and TDK Ventures.",
      "Founded in 2020, Exponent Energy develops a full-stack EV charging ecosystem combining battery technology, charging stations, and software.",
      "The startup focuses on rapid-charging technology designed to significantly reduce charging time for commercial electric vehicles.",
      "Exponent Energy plans to leverage the investment to scale its charging network, enhance its technology platform, and support a wider range of vehicles.",
      "The latest raise highlights the growing importance of rapid-charging solutions in enabling the next phase of EV adoption in India.",
    ],
  },
  {
    id: 45,
    slug: "quick-commerce-race-heats-up-as-instamarts-market-share-declines",
    tag: "TRENDS",
    status: "Draft",
    title: "Quick Commerce Race Heats Up as Instamart’s Market Share Declines",
    subtitle:
      "Instamart’s grip on the quick commerce market is weakening, with its share shrinking from 34% to 21% over the past two years.",
    time: "10 Jun",
    published: "10 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/quick-commerce-race-heats-up-as-instamarts-market-share-declines.webp",
    pullQuote: `"While Instamart processed more than 270 million orders, competitors such as Blinkit and Zepto expanded at a faster pace, capturing a larger portion of the market."`,
    body: [
      "Swiggy-owned Instamart has witnessed a sharp decline in its share among India’s leading quick commerce players, falling to 21%.",
      "The gap between Instamart and rivals widened in FY25 as Blinkit and Zepto aggressively expanded their dark store networks.",
      "India’s quick commerce industry has evolved rapidly from groceries into broader convenience commerce, driving massive investments.",
      "Despite the decline, Instamart remains one of the largest platforms, but faces concerns over slower growth compared to key rivals.",
      "As the battle intensifies, platforms are focusing on improving profitability and operational efficiency alongside market growth.",
    ],
  },
  {
    id: 46,
    slug: "ai-startup-hypernorm-ai-raises-fresh-capital-to-transform-wealth-management",
    tag: "FUNDING",
    status: "Draft",
    title:
      "AI Startup HyperNorm AI Raises Fresh Capital to Transform Wealth Management",
    subtitle:
      "HyperNorm AI is building the next generation of wealth advisory tools after raising $2.2 million in fresh funding.",
    time: "10 Jun",
    published: "10 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/ai-startup-hypernorm-ai-raises-fresh-capital-to-transform-wealth-management.webp",
    pullQuote: `"The platform aims to help financial advisors make better investment decisions by leveraging AI to analyze large volumes of market data."`,
    body: [
      "WealthTech startup HyperNorm AI has raised $2.2 million in a seed funding round to build an intelligence platform for wealth advisors.",
      "The startup addresses a major challenge in wealth management: turning vast amounts of market and portfolio data into actionable insights.",
      "HyperNorm AI plans to use the capital to accelerate product development and enhance its platform’s intelligence layer.",
      "The funding reflects the increasing adoption of AI-powered tools across the financial services industry for research and risk assessment.",
      "HyperNorm AI aims to transform how financial professionals serve clients by simplifying complex decision-making processes.",
    ],
  },
  {
    id: 47,
    slug: "community-management-startup-mygate-raises-225-cr-in-fresh-funding",
    tag: "FUNDING",
    status: "Draft",
    title:
      "Community Management Startup MyGate Raises ₹225 Cr in Fresh Funding",
    subtitle:
      "Fresh funding of ₹225 crore will help MyGate accelerate expansion and strengthen its position in India’s growing residential technology market.",
    time: "10 Jun",
    published: "10 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/community-management-startup-mygate-raises-225-cr-in-fresh-funding.webp",
    pullQuote: `"As urban residential complexes embrace digital tools, MyGate sees a growing opportunity to become an integrated platform for community living."`,
    body: [
      "Community management platform MyGate has raised ₹225 crore from Dharana Capital to expand its footprint in residential technology.",
      "Founded in 2016, MyGate enables communities to manage visitor access, security, payments, and communication through a single app.",
      "The fresh capital will scale operations, enhance product capabilities, and support the expansion of local commerce offerings.",
      "The investment highlights continued investor confidence in proptech startups solving everyday challenges for residential societies.",
      "MyGate currently serves millions of residents and is aiming to significantly expand its reach in the coming years.",
    ],
  },
  {
    id: 48,
    slug: "child-healthcare-startup-hoola-health-raises-5-mn-in-funding-round-led-by-peak-xvs-surge",
    tag: "FUNDING",
    status: "Draft",
    title:
      "Child Healthcare Startup Hoola Health Raises $5 Mn in Funding Round Led by Peak XV’s Surge",
    subtitle:
      "Backed by Peak XV’s Surge, Hoola Health is expanding its child healthcare platform after securing $5 million in fresh funding.",
    time: "10 Jun",
    published: "10 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/child-healthcare-startup-hoola-health-raises-5-mn-in-funding-round-led-by-peak-xvs-surge.webp",
    pullQuote: `"The funding highlights growing investor interest in startups focused on addressing gaps in specialized child healthcare."`,
    body: [
      "Child healthcare startup Hoola Health raised $5 million in a round led by Peak XV’s Surge to expand its tech-driven platform.",
      "The startup combines digital tools with medical expertise to simplify how parents access specialized pediatric healthcare services.",
      "The fresh capital will scale operations, enhance technology capabilities, and broaden the startup’s reach among families.",
      "The child healthcare segment remains relatively underserved, driving demand for startups developing focused, preventive care solutions.",
      "Hoola Health aims to strengthen its presence in the market and deliver better healthcare outcomes through its scalable platform.",
    ],
  },
  {
    id: 49,
    slug: "punjab-to-become-startup-hub-of-india-cm-mann-announces-1-07-cr-support-for-31-startups",
    tag: "POLICY",
    status: "Draft",
    title:
      "Punjab to Become Startup Hub of India: CM Mann Announces ₹1.07 Cr Support for 31 Startups",
    subtitle:
      "Punjab Chief Minister Bhagwant Mann has announced ₹1.07 crore in seed grants for 31 startups to boost innovation and job creation.",
    time: "11 Jun",
    published: "11 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/punjab-to-become-startup-hub-of-india-cm-mann-announces-1-07-cr-support-for-31-startups.webp",
    pullQuote: `"A stronger startup ecosystem can contribute to employment generation, attract investment, and create long-term value for the regional economy," officials stated.`,
    body: [
      "Punjab is doubling down on its startup ambitions, providing ₹1.07 crore in seed grants to 31 early-stage startups across various sectors.",
      "Chief Minister Bhagwant Mann reiterated his vision to transform Punjab into a leading innovation hub, focusing on local entrepreneurship and job creation.",
      "The financial support is part of the state's promotion initiatives designed to help founders build scalable businesses and navigate early-stage capital challenges.",
      "The state government has also introduced enhanced financial incentives to improve the overall startup support framework.",
      "By strengthening funding access, Punjab aims to attract more innovators and keep young entrepreneurs from seeking opportunities elsewhere.",
    ],
  },
  {
    id: 50,
    slug: "healthtech-startup-qubehealth-pay-secures-series-a-round-valuation-reaches-416-cr",
    tag: "FUNDING",
    status: "Draft",
    title:
      "Healthtech Startup QubeHealth-Pay Secures Series A Round, Valuation Reaches ₹416 Cr",
    subtitle:
      "QubeHealth-Pay has raised a Series A funding round at a valuation of ₹416 crore to expand its healthcare payments and financing platform.",
    time: "11 Jun",
    published: "11 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/healthtech-startup-qubehealth-pay-secures-series-a-round-valuation-reaches-416-cr.webp",
    pullQuote: `"QubeHealth-Pay's platform aims to make healthcare spending more predictable and manageable through flexible payment options."`,
    body: [
      "Healthcare payments startup QubeHealth-Pay raised fresh capital in a Series A round, valuing the company at ₹416 crore.",
      "Founded by Chris George and Gagan Kapur, the startup provides flexible payment options to help individuals manage medical expenses efficiently.",
      "The new funding will support expansion plans and the development of additional products within its healthcare-financing ecosystem.",
      "QubeHealth-Pay partners with employers, healthcare providers, and financial institutions to improve healthcare accessibility while reducing financial stress.",
      "The deal adds to the growing momentum of startups operating at the intersection of healthcare and fintech in India.",
    ],
  },
  {
    id: 51,
    slug: "deeptech-startup-ethereal-machines-raises-28-5-mn-in-series-b-led-by-avataar-ventures",
    tag: "FUNDING",
    status: "Draft",
    title:
      "Deeptech Startup Ethereal Machines Raises $28.5 Mn in Series B Led by Avataar Ventures",
    subtitle:
      "Ethereal Machines raised $28.5 million in Series B funding to scale its advanced manufacturing capabilities and multi-axis CNC technologies.",
    time: "11 Jun",
    published: "11 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/deeptech-startup-ethereal-machines-raises-28-5-mn-in-series-b-led-by-avataar-ventures.webp",
    pullQuote: `"The funding marks another strong signal of confidence in India’s rapidly evolving deeptech landscape and manufacturing ambitions."`,
    body: [
      "Bengaluru-based Ethereal Machines secured $28.5 million in Series B funding led by Avataar Ventures, with Peak XV Partners participating.",
      "Founded in 2020, the startup specializes in high-precision manufacturing technologies, combining hardware innovation with software-driven solutions.",
      "The capital will expand production capacity, accelerate R&D, and strengthen the company's presence in domestic and international markets.",
      "Ethereal Machines serves specialized industries such as aerospace, defense, electronics, healthcare, and precision engineering.",
      "The investment reflects growing interest from venture capital firms in deeptech startups building proprietary industrial solutions.",
    ],
  },
  {
    id: 52,
    slug: "mamaearth-parent-honasa-eyes-5500-cr-revenue-by-fy31-amid-growth-push",
    tag: "GROWTH",
    status: "Draft",
    title:
      "Mamaearth Parent Honasa Eyes ₹5,500 Cr Revenue by FY31 Amid Growth Push",
    subtitle:
      "Honasa Consumer, the parent company of Mamaearth, targets ₹5,500 crore in revenue by FY31, focusing on brand expansion and profitable growth.",
    time: "11 Jun",
    published: "11 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/mamaearth-parent-honasa-eyes-5500-cr-revenue-by-fy31-amid-growth-push.webp",
    pullQuote: `"The company plans to build additional high-scale brands to create multiple category leaders across India's beauty and personal care market."`,
    body: [
      "Honasa Consumer has unveiled a long-term roadmap aiming to achieve over ₹5,500 crore in revenue by FY31, more than doubling its current scale.",
      "The beauty and personal care major reported revenue of nearly ₹2,392 crore in FY26 while delivering strong profit growth.",
      "Honasa plans to strengthen its omnichannel presence across online marketplaces, quick commerce platforms, and traditional retail outlets.",
      "The strategy involves reducing dependence on flagship brands Mamaearth and The Derma Co. by scaling new brands within its portfolio.",
      "The company also aims to achieve an EBITDA margin of more than 15% by FY31 through operational efficiencies and continued innovation.",
    ],
  },
  {
    id: 53,
    slug: "cancer-genomics-startup-4basecare-closes-128-cr-series-b-round-with-fresh-38-cr-raise",
    tag: "FUNDING",
    status: "Draft",
    title:
      "Cancer Genomics Startup 4baseCare Closes ₹128 Cr Series B Round With Fresh ₹38 Cr Raise",
    subtitle:
      "4baseCare has secured an additional ₹38 crore, taking its Series B round to ₹128 crore to strengthen its precision oncology offerings.",
    time: "11 Jun",
    published: "11 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/cancer-genomics-startup-4basecare-closes-128-cr-series-b-round-with-fresh-38-cr-raise.webp",
    pullQuote: `"4baseCare aims to accelerate innovation, strengthen partnerships, and expand the reach of its precision oncology offerings globally."`,
    body: [
      "Healthtech startup 4baseCare closed its Series B round at ₹128 crore after securing an additional ₹38 crore in fresh capital.",
      "Founded in 2018, the startup leverages genomics and advanced technology to help healthcare providers deliver personalized cancer treatments.",
      "The funding will strengthen its technology platform, expand laboratory capabilities, and broaden its footprint in international markets.",
      "Demand for personalized healthcare solutions is growing, attracting investors to startups operating in genomics and precision medicine.",
      "4baseCare's ecosystem combines genomic testing, clinical insights, and digital health tools to assist oncologists with targeted therapies.",
    ],
  },
  {
    id: 54,
    slug: "ai-startup-rivvun-secures-7-5-mn-to-boost-enterprise-revenue-efficiency",
    tag: "FUNDING",
    status: "Draft",
    title:
      "AI Startup Rivvun Secures $7.5 Mn To Boost Enterprise Revenue Efficiency",
    subtitle:
      "Rivvun AI raised $7.5 million to expand its AI-powered software that helps enterprises identify financial inefficiencies and improve revenue realization.",
    time: "11 Jun",
    published: "11 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/ai-startup-rivvun-secures-7-5-mn-to-boost-enterprise-revenue-efficiency.webp",
    pullQuote: `"By leveraging artificial intelligence, Rivvun AI helps organizations uncover missed revenue opportunities and financial inconsistencies."`,
    body: [
      "Enterprise AI startup Rivvun AI has raised $7.5 million in fresh funding to expand its technology platform focused on revenue leakages.",
      "The startup's software analyzes enterprise data to identify inefficiencies, process gaps, and billing errors hidden within complex operations.",
      "The newly secured capital will support product development, team expansion, and market growth initiatives.",
      "As enterprises generate more data, intelligent tools capable of identifying hidden financial risks have become increasingly important.",
      "The investment highlights continued confidence in AI-driven enterprise solutions that directly impact profitability and financial health.",
    ],
  },
  {
    id: 55,
    slug: "razorpay-takes-first-step-toward-ipo-confidentially-files-drhp-with-sebi",
    tag: "IPO",
    title:
      "Razorpay Takes First Step Toward IPO, Confidentially Files DRHP With SEBI",
    status: "Published",
    subtitle:
      "One of India's biggest fintech success stories is preparing for its next chapter as Razorpay quietly submits draft IPO papers to SEBI.",
    time: "15 Jun",
    published: "15 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/razorpay-takes-first-step-toward-ipo-confidentially-files-drhp-with-sebi.webp",
    markdownBody: `*One of India's biggest fintech success stories is preparing for its next chapter. Razorpay has quietly submitted draft IPO papers to SEBI, setting the stage for a closely watched public market debut.*

After years of powering digital payments for businesses across India, Razorpay is finally preparing for its next big chapter.

The Bengaluru-based fintech giant has confidentially filed its draft IPO papers with the Securities and Exchange Board of India (SEBI), officially beginning the process of going public. The confidential filing route allows companies to initiate regulatory reviews without immediately disclosing sensitive financial and business details to the public.

Founded in 2014, Razorpay started as a payments solution for online businesses but has since evolved into a broader financial platform. Today, the company offers a range of services including payment processing, business banking, payouts, payroll solutions, and other financial tools used by startups, SMEs, and large enterprises.

The IPO filing comes at a crucial time for India's startup ecosystem. After a period marked by funding slowdowns and valuation resets, investors have begun showing renewed interest in businesses with strong fundamentals and sustainable growth. Razorpay's decision to move ahead with a public listing is likely to be seen as a confidence signal for the broader technology and startup sector.

According to reports, the company could look to raise around $600 million through the offering, although the final issue size and valuation are yet to be disclosed. Earlier reports had suggested Razorpay may seek a valuation in the range of $5 billion to $6 billion.

The development is being closely watched by founders, investors, and market participants alike. As one of India's most recognizable fintech success stories, Razorpay's public market debut could become a defining moment not only for the company but also for the next wave of venture-backed startups considering IPO plans.

While the finer details of the offering remain under wraps, one thing is certain: Razorpay's long-awaited journey to the stock market is now officially underway.`,
  },
  {
    id: 56,
    slug: "after-turning-profitable-pine-labs-faces-questions-over-a-key-revenue-stream",
    tag: "FINTECH",
    status: "Published",
    title:
      "After Turning Profitable, Pine Labs Faces Questions Over a Key Revenue Stream",
    subtitle:
      "Pine Labs achieved profitability, but its gift card business faces regulatory changes that could challenge the sustainability of this high-margin income.",
    time: "15 Jun",
    published: "15 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/after-turning-profitable-pine-labs-faces-questions-over-a-key-revenue-stream.webp",
    markdownBody: `*Pine Labs has achieved a major profitability turnaround, but a key revenue driver could soon face pressure. The fintech firm's gift card business, built through its Qwikcilver acquisition, has been a significant contributor to earnings. However, regulatory changes may challenge the sustainability of this high-margin income stream.*

For years, Pine Labs was known as one of India's most valuable fintech startups chasing scale. Now, it has something many venture-backed companies struggle to achieve: profitability.

The fintech firm recently reported a profitable year, marking a significant milestone in its journey from a payments infrastructure company to a broader financial technology platform. But a closer look at the business reveals that one segment has played a particularly important role in supporting that performance the gift card business.

Pine Labs strengthened its position in this category through its acquisition of Qwikcilver, a company that became one of India's largest gift card and stored-value solutions providers. Over time, the business evolved into an important revenue contributor, serving brands, retailers, and corporate customers across the country.

However, the segment now finds itself at the center of an evolving regulatory landscape. Industry participants are closely monitoring changes that could affect how prepaid instruments and gift card products operate in the future. While the long-term impact remains uncertain, any disruption to this segment would be significant given its contribution to Pine Labs' broader business.

That said, Pine Labs today is far more diversified than it was a few years ago. Beyond gift cards, the company has built businesses across merchant payments, online commerce, lending partnerships, and software-led financial services. These segments are expected to play an increasingly important role as the company continues to scale.

For investors and industry observers, the bigger question is no longer whether Pine Labs can become profitable. It already has. The focus now shifts to whether the company can sustain and expand those profits as its business mix evolves and regulatory conditions change.

The next phase of Pine Labs' story may not be about reaching profitability it may be about proving that profitability can last.`,
  },
  {
    id: 57,
    slug: "from-ideas-to-25-lakh-jobs-indias-startup-ecosystem-keeps-growing",
    tag: "ECOSYSTEM",
    status: "Published",
    title:
      "From Ideas to 25 Lakh Jobs: India's Startup Ecosystem Keeps Growing",
    subtitle:
      "India now has over 2.3 lakh recognized startups that have collectively generated more than 25 lakh jobs, highlighting their economic impact.",
    time: "15 Jun",
    published: "15 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/from-ideas-to-25-lakh-jobs-indias-startup-ecosystem-keeps-growing.webp",
    markdownBody: `*India's startup ecosystem has crossed another major milestone. According to Union Minister Jitendra Singh, the country now has over 2.3 lakh recognized startups that have collectively generated more than 25 lakh jobs, highlighting the growing role of entrepreneurship in shaping the nation's economy.*

A decade ago, building a startup in India was still considered a risky path. Today, it has become one of the country's biggest engines of innovation, employment, and economic growth.

Speaking about the evolution of India's entrepreneurial landscape, Union Minister Jitendra Singh said the country now has more than 2.3 lakh recognized startups that have together created over 25 lakh jobs. The figures reflect the remarkable expansion of the startup ecosystem and the increasing contribution of young companies to India's growth story.

The transformation has been driven by a combination of factors, including greater access to capital, improved digital infrastructure, supportive government initiatives, and a growing culture of innovation. What was once concentrated in cities like Bengaluru, Mumbai, and Delhi has now spread to smaller towns and emerging startup hubs across the country.

India's startup ecosystem has also diversified significantly over the years. From fintech and e-commerce to deeptech, artificial intelligence, healthtech, agritech, and space technology, entrepreneurs are building solutions across a wide range of industries. This has not only attracted investment but also created employment opportunities for millions of people.

Beyond the headline numbers, the milestone highlights a broader shift in India's economy. Startups are no longer viewed merely as technology ventures chasing growth; they have become meaningful contributors to job creation, innovation, and economic development.

As India pushes deeper into emerging technologies and innovation-led sectors, the startup ecosystem is expected to play an even larger role in shaping the country's future. For founders, investors, and policymakers, the latest figures serve as a reminder of how far the ecosystem has come and how much potential still lies ahead.`,
  },
  {
    id: 58,
    slug: "at-just-16-pranjali-awasthi-is-already-running-a-100-crore-startup",
    tag: "FOUNDER STORY",
    status: "Published",
    title:
      "At Just 16, Pranjali Awasthi Is Already Running a ₹100 Crore Startup",
    subtitle:
      "16-year-old entrepreneur Pranjali Awasthi has built Delv.AI, an artificial intelligence startup reportedly valued at nearly ₹100 crore.",
    time: "15 Jun",
    published: "15 June 2026",
    author: "Startup Unplugged",
    cover:
      "/news/at-just-16-pranjali-awasthi-is-already-running-a-100-crore-startup.webp",
    markdownBody: `*While most teenagers are focused on school and exams, Pranjali Awasthi is building in the world of artificial intelligence. The 16-year-old entrepreneur, who began learning coding at the age of seven, has built Delv.AI, a startup reportedly valued at nearly ₹100 crore.*

Most startup founders spend years gaining experience before launching a company. Pranjali Awasthi's journey followed a very different timeline.

At just 16 years old, the Indian-origin entrepreneur has already built Delv.AI, an artificial intelligence startup that has attracted investor attention and is reportedly valued at nearly ₹100 crore. Her story is quickly becoming one of the most talked-about examples of young entrepreneurship in the AI era.

Pranjali's interest in technology began early. Encouraged by her father, she started learning coding when she was just seven years old. What began as curiosity soon turned into a serious passion for computer science, artificial intelligence, and machine learning.

After moving to the United States, she continued sharpening her technical skills and gained hands-on exposure through research internships focused on machine learning. During this period, she noticed a common challenge faced by researchers and professionals: finding and organizing useful information from large volumes of online content.

That observation eventually led to the creation of Delv.AI, a platform designed to help users discover, filter, and analyze information more efficiently using artificial intelligence.

Founded in 2022, the startup went on to attract investor backing and gain recognition within the startup ecosystem. For many observers, the company's growth is impressive. But what makes the story truly stand out is the age of its founder.

In a world where artificial intelligence is creating new opportunities for builders and innovators, Pranjali's journey highlights how curiosity, consistency, and early exposure to technology can translate into real-world impact.

Her story is not just about building a startup. It's about proving that age is no longer a barrier to creating something meaningful in the technology industry.`,
  },
  {
    id: 59,
    slug: "amazons-new-ai-tool-could-save-sellers-hours-every-week",
    tag: "TECH",
    status: "Published",
    title: "Amazon's New AI Tool Could Save Sellers Hours Every Week",
    subtitle:
      "Amazon has introduced an AI-powered assistant designed to help merchants manage listings, inventory, and business operations more efficiently.",
    time: "15 Jun",
    published: "15 June 2026",
    author: "Startup Unplugged",
    cover: "/news/amazons-new-ai-tool-could-save-sellers-hours-every-week.webp",
    markdownBody: `*Amazon is bringing artificial intelligence directly into seller workflows with a new AI-powered assistant. Designed to help merchants manage listings, inventory, advertising, and business operations, the tool aims to reduce manual work and help sellers focus more on growth.*

Running an online business often involves far more than selling products. Merchants spend countless hours managing listings, monitoring inventory, optimizing ads, and navigating operational challenges that can slow growth.

Amazon believes AI can help change that.

The ecommerce giant has introduced an AI-powered Seller Assistant for merchants, expanding its efforts to integrate artificial intelligence across its marketplace ecosystem. The assistant is designed to provide sellers with real-time support, personalized recommendations, and faster access to information needed to run their businesses more efficiently.

Instead of searching through multiple dashboards and help documents, sellers can interact with the assistant using natural language. The tool can help answer questions, assist with catalog management, provide inventory-related insights, support advertising decisions, and guide businesses through various operational processes.

The launch reflects Amazon's growing focus on embedding AI into everyday business workflows. Over the past year, technology companies have increasingly moved beyond chatbots and content generation tools, using AI to automate complex business tasks and improve productivity.

For sellers, the biggest advantage could be time. Many small and medium-sized businesses lack dedicated teams for operations, marketing, and analytics. By simplifying routine tasks and surfacing relevant insights, AI assistants could help entrepreneurs spend less time managing systems and more time growing their businesses.

The move also highlights how competition in ecommerce is evolving. Platforms are no longer competing solely on reach and logistics; they are increasingly competing on the tools they provide to help merchants succeed.

As artificial intelligence becomes more deeply integrated into commerce, Amazon is positioning itself to make AI a core part of the seller experience. For businesses operating on the platform, that could mean fewer operational headaches and faster decision-making in an increasingly competitive online marketplace.`,
  },
];

export const articlesAll = [
  {
    slug: "why-ai-agents-could-become-every-startups-first-employee",
    tag: "AI and Future of Work",

    title: "Why AI Agents Could Become Every Startup's First Employee",
    excerpt: "Startups have always been about doing more with less.",
    cover:
      "/articles/why-ai-agents-could-become-every-startups-first-employee.webp",
    author: "Team Startup Unplugged",
    read: "3 Minutes",
    published: "4 June 2026",
    publishedAt: "2026-06-04",
    contentBlocks: [
      {
        type: "paragraph",
        content: "Startups have always been about doing more with less.",
      },
      {
        type: "paragraph",
        content:
          "A few years ago, a founder needed a team to handle research, content, customer support, and operations. Today, many of these tasks can be supported by AI agents.",
      },
      {
        type: "paragraph",
        content:
          "While AI is not replacing founders or employees, it is helping startups move faster, operate leaner, and focus on what matters most: building great products and serving customers.",
      },
      {
        type: "quote",
        content: "The biggest advantage isn't cost savings. It's speed.",
      },
      { type: "heading", level: 2, content: "What Is Changing?" },
      {
        type: "paragraph",
        content: "AI agents are becoming digital teammates. They can:",
      },
      {
        type: "list",
        style: "unordered",
        items: [
          "Research competitors",
          "Draft content",
          "Summarize meetings",
          "Answer customer queries",
          "Organize workflows",
          "Generate reports",
        ],
      },
      {
        type: "paragraph",
        content:
          "For an early-stage startup, that means fewer repetitive tasks and more time spent on growth.",
      },
      {
        type: "paragraph",
        content:
          "A founder who previously spent hours gathering information can now focus on strategy, customers, and execution.",
      },
      { type: "heading", level: 2, content: "Why It Matters" },
      {
        type: "paragraph",
        content: "The startup ecosystem is moving towards lean teams.",
      },
      {
        type: "paragraph",
        content:
          "Investors are increasingly looking for businesses that can scale efficiently rather than simply adding more people.",
      },
      {
        type: "paragraph",
        content:
          "AI agents help startups improve productivity without significantly increasing operational costs. This creates an advantage for small teams that know how to use technology effectively.",
      },
      {
        type: "paragraph",
        content:
          "The startups that adopt AI early are likely to learn faster and execute better than competitors who ignore it.",
      },
      { type: "heading", level: 2, content: "What Startup Unplugged Thinks!" },
      {
        type: "paragraph",
        content:
          "AI agents should not be viewed as a replacement for people. They should be viewed as a productivity layer.",
      },
      {
        type: "paragraph",
        content:
          "The next generation of successful startups may not be the ones with the biggest teams. They may be the ones that combine human creativity with AI-powered execution.",
      },
      {
        type: "quote",
        content:
          "For founders, AI is not a hiring strategy. It's an efficiency strategy.",
      },
      { type: "heading", level: 2, content: "Looking Ahead" },
      {
        type: "paragraph",
        content: "Every major business shift creates new winners.",
      },
      {
        type: "list",
        style: "unordered",
        items: [
          "The internet changed how companies reached customers.",
          "Cloud computing changed how startups scaled.",
          "AI agents could change how teams operate.",
        ],
      },
      {
        type: "paragraph",
        content:
          "The question isn't whether startups will use AI. The question is, who will learn to use it best?",
      },
      {
        type: "questionForm",
        question:
          "If AI handles repetitive work, where should founders spend more of their time: Product, Customers, or Growth?",
      },
    ],
  },
  {
    slug: "the-new-funding-reality-investors-are-backing-efficiency-over-hype",
    tag: "Startups & Funding",

    title:
      "The New Funding Reality: Investors Are Backing Efficiency Over Hype",
    excerpt:
      "Just a few years ago, startup funding was driven by one thing: growth.",
    cover:
      "/articles/the-new-funding-reality-investors-are-backing-efficiency-over-hype.webp",
    author: "Team Startup Unplugged",
    read: "3 Minutes",
    published: "4 June 2026",
    publishedAt: "2026-06-04",
    contentBlocks: [
      {
        type: "paragraph",
        content:
          "Just a few years ago, startup funding was driven by one thing: growth.",
      },
      {
        type: "paragraph",
        content:
          "The faster a company acquired users, expanded markets, and increased valuation, the easier it was to attract investor attention.",
      },
      { type: "paragraph", content: "Today, the rules have changed." },
      {
        type: "paragraph",
        content:
          "Investors are becoming more selective. Instead of focusing purely on growth, they are paying closer attention to profitability, operational efficiency, and long-term sustainability.",
      },
      {
        type: "paragraph",
        content:
          "For founders, this marks a significant shift in how businesses are built and funded.",
      },
      { type: "heading", level: 2, content: "What Is Changing?" },
      {
        type: "paragraph",
        content:
          'The startup ecosystem is moving away from the "growth at all costs" mindset.',
      },
      { type: "paragraph", content: "Investors now want to understand:" },
      {
        type: "list",
        style: "unordered",
        items: [
          "How efficiently a startup uses capital",
          "Whether the business can generate sustainable revenue",
          "Customer retention and loyalty",
          "Unit economics",
          "The path to profitability",
        ],
      },
      {
        type: "quote",
        content:
          "The goal is no longer just scaling quickly. It's scaling responsibly.",
      },
      { type: "heading", level: 2, content: "Why It Matters" },
      {
        type: "paragraph",
        content:
          "Raising capital is becoming more competitive. Founders can no longer rely solely on ambitious projections and market size.",
      },
      {
        type: "paragraph",
        content:
          "Businesses that demonstrate strong fundamentals are gaining more investor confidence.",
      },
      {
        type: "paragraph",
        content: "This shift is encouraging startups to focus on:",
      },
      {
        type: "list",
        style: "unordered",
        items: [
          "Better cash management",
          "Sustainable growth",
          "Stronger business models",
          "Long-term value creation",
        ],
      },
      {
        type: "paragraph",
        content:
          "For the startup ecosystem, this could lead to healthier and more resilient companies.",
      },
      { type: "heading", level: 2, content: "Startup Unplugged Perspective" },
      {
        type: "paragraph",
        content:
          "The funding environment hasn't become tougher. It has become smarter.",
      },
      {
        type: "paragraph",
        content:
          "Investors are rewarding businesses that solve real problems, manage resources effectively, and create long-term value.",
      },
      {
        type: "paragraph",
        content:
          "For founders, the message is clear: Building a great business is becoming more important than building a great funding story.",
      },
      {
        type: "heading",
        level: 2,
        content: "What Industry Leaders Are Saying",
      },
      {
        type: "paragraph",
        content:
          "Warren Buffett has long emphasized the importance of value creation over hype.",
      },
      {
        type: "paragraph",
        content:
          "While startups operate differently from traditional businesses, the principle remains relevant: sustainable businesses ultimately attract sustainable investment.",
      },
      {
        type: "paragraph",
        content:
          "Many leading investors today are looking beyond short-term growth metrics and focusing on companies with strong fundamentals and disciplined execution.",
      },
      { type: "heading", level: 2, content: "Looking Ahead" },
      {
        type: "paragraph",
        content:
          "The next wave of successful startups may not be the ones raising the most capital. They may be the ones using capital most effectively.",
      },
      {
        type: "paragraph",
        content:
          "As the funding landscape evolves, founders who prioritize efficiency, profitability, and customer value will likely be in a stronger position to attract investors and build lasting businesses.",
      },
      {
        type: "questionForm",
        question:
          "If you were an investor today, would you prioritize rapid growth or sustainable profitability when evaluating a startup?",
      },
    ],
  },
  {
    slug: "the-real-startup-everyone-is-building-today-themselves",
    tag: "Founders & Career Growth",

    title: "The Real Startup Everyone Is Building Today: Themselves",
    excerpt:
      "A few years ago, success looked fairly simple. Get a good job, work hard, earn promotions...",
    cover:
      "/articles/the-real-startup-everyone-is-building-today-themselves.webp",
    author: "Team Startup Unplugged",
    read: "3 Min Read",
    published: "4 June 2026",
    publishedAt: "2026-06-04",
    contentBlocks: [
      {
        type: "paragraph",
        content: "A few years ago, success looked fairly simple.",
      },
      {
        type: "paragraph",
        content:
          "Get a good job, work hard, earn promotions, and slowly climb the corporate ladder.",
      },
      { type: "paragraph", content: "Today, something feels different." },
      {
        type: "paragraph",
        content:
          "People are still building careers, but they're also building something much more personal. They're building a reputation.",
      },
      {
        type: "paragraph",
        content:
          "Whether it's through LinkedIn posts, newsletters, podcasts, side projects, online communities, or simply sharing their experiences, more professionals are investing time in creating a personal brand. Not because it's trendy. Because it creates opportunities.",
      },
      {
        type: "paragraph",
        content:
          "In today's world, people often discover you online before they ever meet you in person. A strong personal brand doesn't mean becoming an influencer. It means becoming visible. The internet has made it possible for anyone to share ideas, document their journey, and build credibility around what they know. One thoughtful post can lead to a job opportunity. One insight can attract a future client. One conversation can lead to a partnership.",
      },
      {
        type: "quote",
        content:
          "The barriers between people and opportunities have become smaller than ever before.",
      },
      {
        type: "paragraph",
        content:
          "What's interesting is that many of the most successful professionals today are not necessarily the loudest people in the room. They're simply consistent. They share what they're learning. They talk about what they're building. They contribute to conversations that matter. Over time, people begin to associate them with a particular expertise, industry, or point of view.",
      },
      { type: "paragraph", content: "And that's where trust begins to form." },
      { type: "heading", level: 2, content: "Startup Unplugged Perspective" },
      {
        type: "paragraph",
        content:
          "The most valuable startup many people will ever build isn't a company. It's their reputation. Companies can change. Job titles can change. Industries can change.",
      },
      {
        type: "paragraph",
        content:
          "But credibility travels with you. The people creating the most opportunities today aren't waiting to become experts before they start sharing.",
      },
      {
        type: "paragraph",
        content:
          "They're learning in public, building in public, and growing alongside their audience. As the professional world becomes increasingly digital, personal brands will likely become even more important.",
      },
      {
        type: "paragraph",
        content:
          "The next generation of opportunities may not come from where you work. They may come from what you share, what you believe, and the community you build around yourself. Because in the attention economy, being talented is important. But being discoverable matters too.",
      },
      {
        type: "questionForm",
        question:
          "If someone searched your name today, what story would they find?",
      },
    ],
  },
  {
    slug: "attention-is-the-new-currency",
    tag: "Business & Growth",

    title: "Attention Is The New Currency",
    excerpt: "The internet has made one thing incredibly affordable. Building.",
    cover: "/articles/attention-is-the-new-currency.webp",
    author: "Team Startup Unplugged",
    read: "3 Min Read",
    published: "4 June 2026",
    publishedAt: "2026-06-04",
    contentBlocks: [
      {
        type: "paragraph",
        content: "The internet has made one thing incredibly affordable.",
      },
      { type: "paragraph", content: "Building." },
      {
        type: "paragraph",
        content:
          "Today, almost anyone can create a product, launch a website, start a newsletter, build an app, or launch a startup. The challenge is no longer creating something. The challenge is getting people to notice it. Attention has become one of the most valuable assets in business. And it's becoming harder to earn every day.",
      },
      {
        type: "paragraph",
        content:
          "Every company is competing for the same thing. Not money. Not talent. Not even customers. Attention.",
      },
      {
        type: "paragraph",
        content:
          "Before someone buys your product, they need to know you exist.",
      },
      {
        type: "video",
        src: "/articles/attention-is-the-new-currency.mp4",
      },

      {
        type: "paragraph",
        content:
          "Before they trust your brand, they need to see you consistently.",
      },
      {
        type: "paragraph",
        content:
          "Before they invest in your company, they need to understand your story.",
      },
      {
        type: "quote",
        content:
          "The battle for attention happens before almost every other business outcome.",
      },
      {
        type: "paragraph",
        content:
          "This is why founder-led content, personal branding, communities, newsletters, podcasts, and social media have become so important.",
      },
      {
        type: "paragraph",
        content: "They aren't distractions. They're distribution channels.",
      },
      {
        type: "paragraph",
        content:
          "The best startups understand that building a great product is only half the equation. The other half is making sure people know about it.",
      },
      { type: "heading", level: 2, content: "Startup Unplugged Perspective" },
      {
        type: "paragraph",
        content:
          "Many founders spend years perfecting products. Very few spend enough time building distribution.",
      },
      {
        type: "paragraph",
        content:
          "A great product with no attention often struggles. A good product with strong distribution can scale much faster. The winners are usually not those who build first. They're the ones who learn how to distribute.",
      },
      {
        type: "heading",
        level: 2,
        content: "Look around today's startup ecosystem.",
      },
      {
        type: "paragraph",
        content:
          "Some of the fastest-growing companies are not necessarily creating the most revolutionary products.",
      },
      {
        type: "paragraph",
        content:
          "They are creating the strongest conversations. They're building audiences before they build customers. Communities before they build products.",
      },
      { type: "paragraph", content: "Trust before they ask for transactions." },
      {
        type: "questionForm",
        question:
          "What's harder today: building a great product or getting people to pay attention to it?",
      },
    ],
  },
  {
    slug: "why-smart-people-are-choosing-smaller-companies",
    tag: "Future of Work",

    title: "Why Smart People Are Choosing Smaller Companies",
    excerpt:
      "For a long time, career success followed a fairly predictable path.",
    cover: "/articles/why-smart-people-are-choosing-smaller-companies.webp",
    author: "Team Startup Unplugged",
    read: "3 Min Read",
    published: "4 June 2026",
    publishedAt: "2026-06-04",
    contentBlocks: [
      {
        type: "paragraph",
        content:
          "For a long time, career success followed a fairly predictable path. The most talented graduates aimed for large companies, established brands, and stable career ladders. Bigger companies often meant better opportunities, stronger resumes, and greater prestige. While that mindset still exists, a growing number of professionals are making a different choice. Instead of chasing size, they are chasing impact.",
      },
      {
        type: "paragraph",
        content:
          "Smaller companies and startups are becoming increasingly attractive to people who want to learn faster, take ownership, and work closer to decision-making. In a large organization, it can take months to see the outcome of your work. Teams are larger, processes are more structured, and responsibilities are often narrowly defined. In a smaller company, the experience is very different. Employees are not just contributing to a business; they are helping shape it.",
      },
      {
        type: "paragraph",
        content:
          "This shift is not necessarily about money or job titles. It is about exposure. Working in a growing company often means wearing multiple hats, solving unfamiliar problems, and gaining direct insight into how businesses are built. Employees get closer access to founders, customers, strategy, and execution. For many ambitious professionals, that experience can be more valuable than a promotion.",
      },
      {
        type: "paragraph",
        content:
          "The startup ecosystem has also changed how people think about careers. Today's professionals are increasingly prioritizing learning, growth, and meaningful work over traditional markers of success. They want to understand how products are built, how customers are acquired, and how companies scale. Smaller organizations often provide opportunities to experience all of these things firsthand.",
      },
      { type: "heading", level: 2, content: "Startup Unplugged Perspective" },
      {
        type: "paragraph",
        content:
          "The smartest professionals are not always looking for the biggest company on their resume. Many are looking for the environment that will accelerate their growth the fastest. Smaller companies may come with uncertainty, but they also offer something that is becoming increasingly valuable: the opportunity to build, learn, and create impact from day one.",
      },
      {
        type: "quote",
        content:
          "Large companies will always play an important role in shaping careers. However, the definition of a dream job is evolving. For many professionals today, success is no longer just about joining a great company. It is about helping build one.",
      },
      {
        type: "questionForm",
        question:
          "If you had the choice today, would you choose the stability of a large company or the opportunity to help build a growing startup?",
      },
    ],
  },
  {
    slug: "what-if-your-dream-job-is-holding-you-back",
    tag: "Perspective",

    title: "What If Your Dream Job Is Holding You Back?",
    excerpt:
      "For years, people have been encouraged to chase their dream job. The assumption is simple...",
    cover: "/articles/what-if-your-dream-job-is-holding-you-back.png",
    author: "Team Startup Unplugged",
    read: "3 Min Read",
    published: "5 June 2026",
    publishedAt: "2026-06-05",
    contentBlocks: [
      {
        type: "paragraph",
        content:
          "For years, people have been encouraged to chase their dream job.",
      },
      {
        type: "paragraph",
        content:
          "The assumption is simple. If you can find the perfect company, the perfect role, and the perfect salary, everything else will fall into place.",
      },
      {
        type: "heading",
        level: 2,
        content: "But what if that's not entirely true?",
      },
      {
        type: "paragraph",
        content:
          "What if the pursuit of a dream job is stopping people from discovering what they are truly capable of building on their own?",
      },
      {
        type: "paragraph",
        content:
          "Many talented professionals spend years optimizing for the next role, the next promotion, or the next company. Very few spend the same amount of time asking a different question:",
      },
      {
        type: "quote",
        content: "What would I build if nobody gave me permission?",
      },
      {
        type: "paragraph",
        content: "That question is becoming increasingly important.",
      },
      {
        type: "paragraph",
        content:
          "The internet has created opportunities that simply did not exist a decade ago. People can build communities, launch products, create content, start businesses, and reach audiences without waiting for a job title to validate them.",
      },
      {
        type: "paragraph",
        content:
          "Yet many still define their ambition through someone else's organization. There is nothing wrong with working for a great company. Some of the world's most successful careers have been built that way.",
      },
      {
        type: "paragraph",
        content:
          "The danger comes when a dream job becomes the final destination rather than a platform for growth. Because the most valuable skill in today's economy is not employment.",
      },
      { type: "paragraph", content: "It is creation." },
      {
        type: "paragraph",
        content:
          "People who know how to build things have options. They can adapt faster, learn faster, and create opportunities for themselves when circumstances change.",
      },
      {
        type: "paragraph",
        content: "That does not mean everyone should become a founder.",
      },
      {
        type: "paragraph",
        content: "It means everyone should think like a builder.",
      },
      { type: "heading", level: 2, content: "Startup Unplugged Perspective" },
      {
        type: "paragraph",
        content:
          "The future may belong to people who are willing to create before they feel ready. The question is no longer where you work. The question is what you are building.",
      },
      {
        type: "paragraph",
        content:
          "Jobs can disappear. Industries can change. Technology can evolve. But the ability to create value will always remain relevant.",
      },
      {
        type: "paragraph",
        content: "Perhaps the goal should not be finding a dream job.",
      },
      {
        type: "paragraph",
        content:
          "Perhaps the goal should be becoming the kind of person who can create opportunities wherever they go.",
      },
      { type: "heading", level: 2, content: "What the Industry thinks:" },
      {
        type: "paragraph",
        content:
          "Investor and entrepreneur Naval Ravikant has often spoken about the power of ownership and leverage. One of his most widely shared ideas is that technology and the internet have given individuals the ability to create and distribute work at a scale that was once only possible for large organizations.",
      },
      {
        type: "paragraph",
        content:
          "The underlying message is simple: building something of your own, whether it is a business, a community, a product, or a body of work, creates opportunities that extend far beyond a job title.",
      },
      {
        type: "paragraph",
        content: "You do not need to quit your job tomorrow.",
      },
      {
        type: "paragraph",
        content:
          "But it may be worth asking yourself what you are building alongside it.",
      },
      {
        type: "questionForm",
        question:
          "If your dream job disappeared tomorrow, what would you start building the next day?",
      },
    ],
  },
  {
    slug: "why-every-startup-is-quietly-becoming-a-media-company",
    tag: "Startups & Growth",

    title: "Why Every Startup Is Quietly Becoming a Media Company",
    excerpt:
      "Not long ago, startups focused on building products. Today, many of them are building audiences too.",
    cover:
      "/articles/why-every-startup-is-quietly-becoming-a-media-company.jpeg",
    author: "Team Startup Unplugged",
    read: "3 Min Read",
    published: "5 June 2026",
    publishedAt: "2026-06-05",
    contentBlocks: [
      {
        type: "paragraph",
        content:
          "Not long ago, startups focused on building products. Today, many of them are building audiences too.",
      },
      {
        type: "paragraph",
        content:
          "Open LinkedIn and you'll find founders sharing lessons, companies publishing insights, and startups launching newsletters, podcasts, events, and communities. What once looked like marketing has become something much bigger.",
      },
      {
        type: "paragraph",
        content:
          "The most successful startups are no longer just competing for customers. They are competing for attention.",
      },
      {
        type: "paragraph",
        content:
          "In a world where products can be copied and features can be replicated, attention has become one of the most valuable business assets.",
      },
      {
        type: "paragraph",
        content:
          "People rarely buy from companies they have never heard of. Before trust comes awareness. Before awareness comes visibility.",
      },
      {
        type: "paragraph",
        content:
          "That's why startups are increasingly behaving like media companies.",
      },
      {
        type: "paragraph",
        content:
          "They are creating content, telling stories, and building communities long before asking people to buy anything.",
      },
      {
        type: "paragraph",
        content:
          "The goal is not simply to sell a product. The goal is to stay top of mind.",
      },
      {
        type: "paragraph",
        content:
          "Companies that consistently educate, entertain, or inform their audience often create an advantage that traditional advertising struggles to replicate.",
      },
      {
        type: "paragraph",
        content:
          "When people already trust your ideas, they are far more likely to trust your products.",
      },
      { type: "heading", level: 2, content: "Startup Unplugged Perspective" },
      {
        type: "paragraph",
        content:
          "The future may belong to startups that know how to distribute ideas, not just products.",
      },
      {
        type: "paragraph",
        content: "Building a great product is still important.",
      },
      {
        type: "paragraph",
        content:
          "But building an audience around that product is becoming equally important.",
      },
      {
        type: "paragraph",
        content:
          "The companies that win attention often earn the opportunity to win customers.",
      },
      { type: "heading", level: 2, content: "What the industry thinks" },
      {
        type: "paragraph",
        content:
          "Entrepreneur and investor Gary Vaynerchuk has long argued that every company should think like a media company.",
      },
      { type: "paragraph", content: "Not because content is the business." },
      {
        type: "paragraph",
        content: "But because attention fuels the business.",
      },
      {
        type: "paragraph",
        content:
          "In an increasingly crowded market, visibility is becoming a competitive advantage.",
      },
      {
        type: "questionForm",
        question:
          "If your startup disappeared from social media tomorrow, would people still remember it?",
      },
    ],
  },
  {
    slug: "the-most-successful-people-you-know-are-probably-playing-a-different-game",
    tag: "Perspective",

    title:
      "The Most Successful People You Know Are Probably Playing a Different Game",
    excerpt:
      "Success can be surprisingly misleading. Look at two people with similar backgrounds and you might wonder why their careers look completely different.",
    cover:
      "/articles/the-most-successful-people-you-know-are-probably-playing-a-different-game.jpeg",
    author: "Team Startup Unplugged",
    read: "3 Min Read",
    published: "5 June 2026",
    publishedAt: "2026-06-05",
    contentBlocks: [
      { type: "paragraph", content: "Success can be surprisingly misleading." },
      {
        type: "paragraph",
        content:
          "Look at two people with similar backgrounds and you might wonder why their careers look completely different.",
      },
      {
        type: "paragraph",
        content:
          "One is chasing promotions. Another is building a startup. Someone else is growing an audience.",
      },
      {
        type: "paragraph",
        content: "Another person is investing quietly in the background.",
      },
      {
        type: "paragraph",
        content:
          "At first glance, it can feel like everyone is competing in the same race.",
      },
      { type: "paragraph", content: "They're not." },
      {
        type: "paragraph",
        content:
          "The reality is that people often optimize for completely different outcomes. Some people want status. Some want freedom. Some want ownership. Some want stability. Some want impact.",
      },
      {
        type: "paragraph",
        content:
          "The confusion begins when we compare our progress to someone playing an entirely different game.",
      },
      {
        type: "paragraph",
        content:
          "A person focused on learning will make different decisions than a person focused on salary.",
      },
      {
        type: "paragraph",
        content:
          "A founder will make different decisions than an employee. A creator will make different decisions than an investor. Different goals produce different paths.",
      },
      {
        type: "paragraph",
        content: "And different paths produce different results.",
      },
      { type: "heading", level: 2, content: "Startup Unplugged Perspective" },
      {
        type: "paragraph",
        content:
          "Many people feel behind because they are measuring themselves against someone else's scoreboard.",
      },
      {
        type: "paragraph",
        content: "The better question is not whether you are winning.",
      },
      {
        type: "paragraph",
        content:
          "The better question is whether you are playing the game you actually want to play.",
      },
      {
        type: "paragraph",
        content:
          "Success becomes easier to understand when you stop comparing outcomes and start comparing intentions.",
      },
      { type: "heading", level: 2, content: "What the industry thinks" },
      {
        type: "paragraph",
        content:
          "Investor and entrepreneur Naval Ravikant has often spoken about designing a life rather than chasing someone else's definition of success.",
      },
      { type: "paragraph", content: "The idea is simple." },
      { type: "paragraph", content: "Clarity matters more than comparison." },
      {
        type: "paragraph",
        content:
          "Because once you know what game you're playing, many distractions disappear.",
      },
      {
        type: "questionForm",
        question:
          "What are you optimizing for right now: money, freedom, learning, ownership, or impact?",
      },
    ],
  },
  {
    slug: "why-everyone-wants-to-be-a-founder-until-its-time-to-pay-salaries",
    tag: "Startup Culture",

    title: "Why Everyone Wants To Be a Founder Until It's Time To Pay Salaries",
    excerpt:
      "Being a founder has never looked more attractive. Social media is filled with fundraising announcements...",
    cover:
      "/articles/why-everyone-wants-to-be-a-founder-until-its-time-to-pay-salaries.jpeg",
    author: "Team Startup Unplugged",
    read: "3 Min Read",
    published: "5 June 2026",
    publishedAt: "2026-06-05",
    contentBlocks: [
      {
        type: "paragraph",
        content: "Being a founder has never looked more attractive.",
      },
      {
        type: "paragraph",
        content:
          "Social media is filled with fundraising announcements, startup launches, podcast appearances, and success stories. From the outside, entrepreneurship often looks exciting.",
      },
      { type: "paragraph", content: "And sometimes it is." },
      {
        type: "paragraph",
        content:
          "What rarely appears online are the moments in between. The difficult conversations. The uncertainty. The pressure of making payroll.",
      },
      {
        type: "paragraph",
        content:
          "The responsibility of leading a team when you don't have all the answers yourself. Founders are often celebrated for taking risks. What is discussed less often is the responsibility that comes after those risks are taken. Every new hire becomes someone depending on the company. Every salary creates accountability.",
      },
      {
        type: "paragraph",
        content:
          "Every decision carries consequences that extend beyond the founder.",
      },
      {
        type: "paragraph",
        content: "That reality changes the way entrepreneurs think.",
      },
      {
        type: "paragraph",
        content: "Building a startup is not just about having an idea.",
      },
      { type: "paragraph", content: "It is about carrying responsibility." },
      { type: "heading", level: 2, content: "Startup Unplugged Perspective" },
      {
        type: "paragraph",
        content:
          "Many people are attracted to the freedom of entrepreneurship.",
      },
      {
        type: "paragraph",
        content: "Far fewer talk about the responsibility that comes with it.",
      },
      {
        type: "paragraph",
        content:
          "Being a founder is not simply about building something for yourself.",
      },
      {
        type: "paragraph",
        content:
          "It is about building something that other people can depend on.",
      },
      {
        type: "paragraph",
        content:
          "The best founders understand that leadership begins where excitement ends.",
      },
      { type: "heading", level: 2, content: "What the industry thinks:" },
      {
        type: "paragraph",
        content:
          "Entrepreneurs like Deepinder Goyal have often spoken about the long journey behind building sustainable companies. From the outside, success can look sudden.",
      },
      {
        type: "paragraph",
        content:
          "From the inside, it is usually years of decisions, uncertainty, and persistence.",
      },
      {
        type: "paragraph",
        content:
          "The headlines often celebrate the outcome. The real story is everything that happened before it.",
      },
      {
        type: "questionForm",
        question:
          "What do you think is harder: starting a company or sustaining one?",
      },
    ],
  },
  {
    slug: "the-new-startup-race-isnt-funding-its-distribution",
    tag: "Startup News & Trends",
    title: "The New Startup Race Isn't Funding. It's Distribution.",
    excerpt:
      "Not long ago, the startup playbook was relatively straightforward. Build a product...",
    cover: "/articles/the-new-startup-race-isnt-funding-its-distribution.webp",
    author: "Team Startup Unplugged",
    read: "3 Min Read",
    published: "15 June 2026",
    publishedAt: "2026-06-15",
    contentBlocks: [
      {
        type: "paragraph",
        content:
          "Not long ago, the startup playbook was relatively straightforward.",
      },
      {
        type: "paragraph",
        content:
          "Build a product, raise capital, hire a team, and then figure out how to acquire customers.",
      },
      {
        type: "paragraph",
        content: "Today, founders are quietly rewriting that playbook.",
      },
      {
        type: "paragraph",
        content:
          "Across India's startup ecosystem, an increasing number of entrepreneurs are spending time on activities that would have seemed unusual a decade ago. They're publishing newsletters, recording podcasts, writing on LinkedIn, building WhatsApp communities, hosting events, and creating content long before their products reach scale.",
      },
      {
        type: "paragraph",
        content: "At first glance, it looks like personal branding.",
      },
      {
        type: "paragraph",
        content:
          "In reality, it's a response to a much larger shift. Distribution has become one of the most valuable assets a startup can own. The internet has dramatically reduced the cost of building. Launching a website, developing software, or creating a digital product is easier than ever. What remains difficult is earning attention. Every founder is competing in an environment where customers are overwhelmed with choices and information.",
      },
      {
        type: "paragraph",
        content:
          "That's why some of today's smartest founders are choosing to build audiences alongside businesses.",
      },
      {
        type: "paragraph",
        content:
          "By the time they launch a new product, announce a feature, or enter a new market, they already have a community listening. Feedback arrives faster. Customer acquisition becomes more efficient. Trust, which usually takes years to build, starts compounding much earlier. This doesn't mean distribution replaces product quality. It doesn't. A weak product will eventually fail regardless of how much attention it receives.",
      },
      {
        type: "paragraph",
        content:
          "But the opposite is increasingly true as well. Great products without distribution often struggle to get noticed. The founders who understand this are treating attention not as a vanity metric, but as infrastructure.",
      },
      { type: "heading", level: 2, content: "Startup Unplugged Perspective" },
      {
        type: "paragraph",
        content:
          "For years, startups viewed marketing as something that happened after the product was built. The next generation of founders appears to be taking a different approach. They're building audiences, communities, and trust from day one. The race for startup success isn't disappearing. It's simply moving upstream.",
      },
      {
        type: "questionForm",
        question:
          "If you were starting a company today, what would you build first: the product or the audience?",
      },
    ],
  },
  {
    slug: "why-whatsapp-is-becoming-indias-new-startup-platform",
    tag: "Startup News & Trends",
    title: "Why WhatsApp Is Becoming India's New Startup Platform",
    excerpt:
      "For years, startups have spent millions trying to convince users to download yet another app. Increasingly, they're realizing they may not need to.",
    cover:
      "/articles/why-whatsapp-is-becoming-indias-new-startup-platform.webp",
    author: "Team Startup Unplugged",
    read: "3 Min Read",
    published: "15 June 2026",
    publishedAt: "2026-06-15",
    contentBlocks: [
      {
        type: "paragraph",
        content:
          "For years, startups have spent millions trying to convince users to download yet another app. Increasingly, they're realizing they may not need to.",
      },
      {
        type: "paragraph",
        content:
          "India is home to one of the world's largest WhatsApp user bases. The app has become far more than a messaging platform. It is where families communicate, businesses engage customers, communities organize themselves, and increasingly, where products are being built. This shift is beginning to influence how startups think about distribution, customer engagement, and even product design.",
      },
      {
        type: "paragraph",
        content:
          "Instead of asking users to create new habits, a growing number of companies are choosing to build around habits that already exist.",
      },
      {
        type: "paragraph",
        content: "The logic is simple.",
      },
      {
        type: "paragraph",
        content:
          "Why spend months convincing someone to open a new app every day when they already spend hours on WhatsApp?",
      },
      {
        type: "paragraph",
        content:
          "The trend is visible across sectors. Educational startups are delivering lessons through chat interfaces. Healthcare companies are using WhatsApp for patient communication. D2C brands are handling customer support, order updates, and repeat purchases directly through messaging. Financial services firms are experimenting with conversational experiences that feel less like software and more like a conversation.",
      },
      {
        type: "paragraph",
        content:
          "What's happening is larger than a platform shift. It reflects a broader change in consumer behaviour. Users increasingly expect businesses to meet them where they already are rather than asking them to move elsewhere.",
      },
      {
        type: "paragraph",
        content:
          "The winners of the next decade may not be the companies with the most sophisticated apps. They may be the companies that remove the most friction.",
      },
      { type: "heading", level: 2, content: "Startup Unplugged Perspective" },
      {
        type: "paragraph",
        content:
          "Technology companies have traditionally focused on building destinations. WhatsApp represents a different approach. Instead of creating a place users must visit, businesses are embedding themselves into existing digital routines.",
      },
      {
        type: "paragraph",
        content: "It's a subtle difference, but an important one.",
      },
      {
        type: "paragraph",
        content:
          "Some of the most successful products in the coming years may not be the ones that demand attention. They may be the ones that quietly become part of everyday life.",
      },
      {
        type: "questionForm",
        question:
          "If your customers already spend hours a day on WhatsApp, does your business really need another app?",
      },
    ],
  },
  {
    slug: "why-being-early-often-feels-exactly-like-being-wrong",
    tag: "Perspective",
    title: "Why Being Early Often Feels Exactly Like Being Wrong",
    excerpt:
      "In hindsight, great ideas always seem obvious. Food delivery feels inevitable today. Electric vehicles appear to be the future.",
    cover: "/articles/why-being-early-often-feels-exactly-like-being-wrong.png",
    author: "Team Startup Unplugged",
    read: "3 Min Read",
    published: "15 June 2026",
    publishedAt: "2026-06-15",
    contentBlocks: [
      {
        type: "paragraph",
        content:
          "In hindsight, great ideas always seem obvious. Food delivery feels inevitable today. Electric vehicles appear to be the future. Creator-led businesses are everywhere.",
      },
      {
        type: "paragraph",
        content: "But reality looks very different when you're early.",
      },
      {
        type: "paragraph",
        content:
          "When an idea is ahead of its time, there are usually no headlines celebrating it. There are no case studies proving it will work. There is no market validation reassuring founders, investors, or customers that they're making the right bet.",
      },
      {
        type: "paragraph",
        content: "Instead, there is uncertainty.",
      },
      {
        type: "paragraph",
        content:
          "People question the opportunity. Customers don't immediately understand the product. Investors struggle to see the market. Friends and colleagues wonder why anyone would leave a stable career to pursue something that appears unproven. That's why being early and being wrong often look identical from the outside.",
      },
      {
        type: "paragraph",
        content:
          "Both involve doubt. Both involve skepticism. Both involve long periods where results are difficult to see. The difference only becomes clear much later.",
      },
      {
        type: "paragraph",
        content:
          "History is filled with examples of ideas that initially seemed unrealistic. Remote work was once considered impractical. Online education faced years of skepticism. Digital payments struggled to gain trust before becoming mainstream.",
      },
      {
        type: "video",
        src: "/articles/why-being-early-often-feels-exactly-like-being-wrong.mp4",
      },
      {
        type: "paragraph",
        content:
          "The founders behind these shifts were not operating with the benefit of hindsight.",
      },
      {
        type: "paragraph",
        content:
          "They were making decisions in real time, without knowing whether the world would eventually agree with them. That is what makes being early so difficult. Timing is often impossible to measure while you're living through it.",
      },
      { type: "heading", level: 2, content: "Startup Unplugged Perspective" },
      {
        type: "paragraph",
        content:
          "One of the biggest misconceptions in business is that great opportunities arrive with obvious signals. More often, they arrive disguised as unpopular opinions. When a trend becomes obvious, competition usually follows.",
      },
      {
        type: "paragraph",
        content:
          "The people who benefit most are often those willing to believe in something before everyone else does. Of course, not every early idea succeeds. But almost every breakthrough idea spends time looking unreasonable.",
      },
      {
        type: "questionForm",
        question:
          "Every generation has opportunities that seem too small, too risky, or too strange at first. The challenge is figuring out whether you're looking at a bad idea or simply an idea that arrived before its time.",
      },
    ],
  },
  {
    slug: "the-founder-who-built-a-community-before-he-built-a-company",
    tag: "NCR Builder Spotlight",
    title: "The Founder Who Built a Community Before He Built a Company",
    excerpt:
      "When most founders start a company, they begin with a product. Prateek Shah started with people.",
    cover:
      "/articles/the-founder-who-built-a-community-before-he-built-a-company.webp",
    author: "Team Startup Unplugged",
    read: "3 Min Read",
    published: "15 June 2026",
    publishedAt: "2026-06-15",
    contentBlocks: [
      {
        type: "paragraph",
        content:
          "When most founders start a company, they begin with a product.",
      },
      {
        type: "paragraph",
        content: "Prateek Shah started with people.",
      },
      {
        type: "paragraph",
        content:
          "Long before GrowthSchool became one of India's most recognized cohort-based learning platforms, Prateek was paying close attention to something happening online. Professionals were consuming more content than ever before, yet many still struggled to acquire practical skills that could directly impact their careers.",
      },
      {
        type: "paragraph",
        content:
          "Courses were everywhere. Transformation was not. The gap wasn't information. The internet had already solved that problem. The gap was accountability, interaction, and learning alongside people with similar goals. That observation became the foundation of GrowthSchool.",
      },
      {
        type: "paragraph",
        content:
          "Instead of creating another library of recorded content, the company focused on building live learning experiences led by industry operators, founders, and professionals. More importantly, it focused on creating a sense of community around learning itself. It was a different approach at a time when much of the edtech industry was focused on scale through content.",
      },
      {
        type: "paragraph",
        content:
          "Prateek and his team were betting that people didn't just want access to knowledge. They wanted access to other ambitious people.",
      },
      {
        type: "paragraph",
        content:
          "Over the years, GrowthSchool attracted thousands of learners across domains ranging from marketing and product management to entrepreneurship and personal growth. What started as an experiment in online learning gradually evolved into a business built around community-led education. Looking back, the most interesting part of the story isn't the platform.",
      },
      {
        type: "paragraph",
        content:
          "It's the sequence. Most companies spend years trying to build communities around their products. GrowthSchool built a product around a community.",
      },
      { type: "heading", level: 2, content: "Startup Unplugged Perspective" },
      {
        type: "paragraph",
        content:
          "One of the most significant shifts in modern business is that audiences are becoming assets. Communities are no longer a by-product of successful companies. In many cases, they are becoming the starting point.",
      },
      {
        type: "paragraph",
        content:
          "The founders who understand this are building differently. They are creating trust before transactions, conversations before conversions, and relationships before revenue.",
      },
      {
        type: "questionForm",
        question:
          "If you were building a company today, would you start with a product or would you start with a community?",
      },
    ],
  },
];

export const featuredArticles = articlesAll.slice(0, 2);

export const founderBytes = [
  {
    id: 1,
    quote:
      "I didn't raise for 18 months. Best thing that ever happened to the company.",
    name: "Karan Mehra",
    role: "Founder, Loopday",
  },
  {
    id: 2,
    quote:
      "Delhi built us in a way Bangalore never could. The hustle is in the water here.",
    name: "Priya Taneja",
    role: "CEO, Monkhold",
  },
  {
    id: 3,
    quote:
      "The first 100 users will teach you more than 100 investors ever will.",
    name: "Arjun Bedi",
    role: "Co-founder, Pitstop.ai",
  },
  {
    id: 4,
    quote:
      "Every NCR founder I know started in a spare bedroom. That's not a flex — that's the stack.",
    name: "Tanvi Malhotra",
    role: "Founder, Sevenly",
  },
];

export const rftVideos = [
  {
    id: 1,
    title: "Raising ₹100 Cr without a pitch deck — with Vivaan Khosla",
    duration: "42:18",
    views: "184K",
    cover:
      "https://images.unsplash.com/photo-1641838005179-d93339564ba9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    video:
      "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4",
    big: true,
  },
  {
    id: 2,
    title: "The Noida PG that produced 6 unicorn employees",
    duration: "18:04",
    views: "62K",
    cover:
      "https://images.unsplash.com/photo-1642086893711-1591cbfa61fe?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    video:
      "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4",
  },
  {
    id: 3,
    title: "Firing your first 10 hires — a brutal conversation",
    duration: "27:51",
    views: "91K",
    cover:
      "https://images.unsplash.com/photo-1596129050968-24ea0d26f0ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    video:
      "https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4",
  },
];

export const events = [
  {
    id: 1,
    date: "14 DEC",
    title: "NCR Founders' Dinner // Vol. 07",
    location: "The Quorum, Gurugram",
    type: "Invite only",
    link: "https://lu.ma/startupunplugged-ncr-dinner-7",
  },
  {
    id: 2,
    date: "19 DEC",
    title: "Unplugged Live: Operators in AI",
    location: "91Springboard, Okhla",
    type: "Open RSVP",
    link: "https://lu.ma/startupunplugged-operators-ai",
  },
  {
    id: 3,
    date: "04 JAN",
    title: "The Cohort Mixer — Investors × Founders",
    location: "Claridges, Lutyens' Delhi",
    type: "Members only",
    link: "https://lu.ma/startupunplugged-cohort-mixer",
  },
  {
    id: 4,
    date: "22 JAN",
    title: "Real Founder Talks — Live Recording",
    location: "AIC, IIIT Delhi",
    type: "Free",
    link: "https://lu.ma/startupunplugged-rft-live",
  },
];

export const cohortStartups = [
  "Loopday",
  "Monkhold",
  "Pitstop.ai",
  "Sevenly",
  "Zerolith",
  "Harbr",
  "Tessera",
  "Northside",
  "Kairo",
  "Routed",
  "Ovent",
  "Paperly",
  "SignalCart",
  "Nimbly",
  "CredNest",
  "FlowLedger",
  "BharatGrid",
  "ScoutOS",
  "Rivet Labs",
  "Stacklane",
  "Kraftly",
  "UrbanMint",
  "PulseOps",
  "Cobalt AI",
  "MesaPay",
  "GrowPilot",
  "ByteHaat",
  "VaultDesk",
];

export const cohortInvestors = [
  {
    name: "Northbridge Capital",
    designation: "Seed fund",
    image: "https://i.pravatar.cc/320?img=12",
  },
  {
    name: "Deeptek Ventures",
    designation: "AI investor",
    image: "https://i.pravatar.cc/320?img=32",
  },
  {
    name: "Kapur Family Office",
    designation: "Family office",
    image: "https://i.pravatar.cc/320?img=47",
  },
  {
    name: "Mint Lane",
    designation: "Angel syndicate",
    image: "https://i.pravatar.cc/320?img=56",
  },
  {
    name: "Verge DLF",
    designation: "Early-stage VC",
    image: "https://i.pravatar.cc/320?img=68",
  },
  {
    name: "Atlas NCR",
    designation: "Operator fund",
    image: "https://i.pravatar.cc/320?img=15",
  },
];

export const cohortMentors = [
  {
    name: "Vikram Shetty",
    designation: "Fintech operator",
    image: "https://i.pravatar.cc/320?img=11",
  },
  {
    name: "Rhea Bajaj",
    designation: "Brand strategist",
    image: "https://i.pravatar.cc/320?img=20",
  },
  {
    name: "Aman Puri",
    designation: "B2B SaaS founder",
    image: "https://i.pravatar.cc/320?img=33",
  },
  {
    name: "Shreya Kapoor",
    designation: "Growth lead",
    image: "https://i.pravatar.cc/320?img=45",
  },
  {
    name: "Naveen Arora",
    designation: "Product mentor",
    image: "https://i.pravatar.cc/320?img=53",
  },
  {
    name: "Isha Gill",
    designation: "Community builder",
    image: "https://i.pravatar.cc/320?img=5",
  },
  {
    name: "Rohan Sethi",
    designation: "Marketplace operator",
    image: "https://i.pravatar.cc/320?img=60",
  },
  {
    name: "Deeksha Vyas",
    designation: "Fundraising coach",
    image: "https://i.pravatar.cc/320?img=25",
  },
];

export const teamMembers = [
  {
    id: 1,
    name: "Karan Talwar",
    role: "Founder",
    bio: "Building the loudest startup media brand in NCR.",
    photo:
      "https://media.licdn.com/dms/image/v2/D5603AQHbiD8TwSwMTA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1711471802696?e=1779926400&v=beta&t=DXoxnQJX_VRWG_2rW-kzoELJw0ZOE5S_wPZIEBu57YI",
    group: "Founders",
    linkedin: "https://www.linkedin.com/in/karan-talwar-0660b1222/",
  },
  {
    id: 2,
    name: "Shounak Sengupta",
    role: "Operations",
    bio: "Story-first. Founder-obsessed. Always shipping.",
    photo:
      "https://media.licdn.com/dms/image/v2/D5603AQEdrZAx4F8JUQ/profile-displayphoto-crop_800_800/B56ZtmKhssJgAI-/0/1766945594754?e=1779926400&v=beta&t=FQ_BHmQjj4TkGLLUN5fwHaa7WKWQWWNVb1HE0uFWy8A",
    group: "Operations",
    linkedin: "https://www.linkedin.com/in/shounak-sengupta-232097122/",
  },
  {
    id: 3,
    name: "Sunil Shimalwal",
    role: "Operations & Growth",
    bio: "Runs the engine room. Cohorts, events, partnerships.",
    photo:
      "https://media.licdn.com/dms/image/v2/D5603AQGuP9FxhtkvFw/profile-displayphoto-shrink_800_800/B56ZiT.kx6G4Ag-/0/1754829323283?e=1779926400&v=beta&t=frv4U_QevcXEMT7SkTUVWUgZzrSGStWvd9bBon5C-5E",
    group: "Core Team",
    linkedin: "https://www.linkedin.com/in/sunilshimalwal/",
  },
  {
    id: 4,
    name: "Shweta Singla",
    role: "Editorial Lead",
    bio: "Where our stories get sharper before they ship.",
    photo:
      "https://media.licdn.com/dms/image/v2/D4D03AQEoZZyQFu8fsA/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1689780657669?e=1779926400&v=beta&t=9r3Dbv6PxnSdvbR1k0HwqLq-k6wYifktK61acOIeQN4",
    group: "Core Team",
    linkedin: "https://www.linkedin.com/in/shweta-singla-570540113/",
  },
  {
    id: 5,
    name: "Nikita Verma",
    role: "Head of Stories",
    bio: "Writes the bits other publications are too polite to print.",
    photo:
      "https://images.unsplash.com/photo-1771580425842-36380c98efc4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    group: "Core Team",
  },
  {
    slug: "the-investor-who-only-writes-cheques-over-chai-in-khan-market",
    name: "Rehan Qureshi",
    role: "Producer, RFT",
    bio: "Knows every founder in NCR on a first-name basis.",
    photo:
      "https://images.unsplash.com/photo-1596129050968-24ea0d26f0ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    group: "Core Team",
  },
  {
    slug: "why-every-ncr-founder-is-suddenly-hiring-from-tier-3-cities",
    name: "Mehak Chawla",
    role: "Contributor",
    bio: "Ex-founder. Writes biweekly about what she broke.",
    photo:
      "https://images.unsplash.com/photo-1771580425842-36380c98efc4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    group: "Contributors",
  },
  {
    slug: "she-raised-her-seed-round-inside-a-dominos-in-sector-18-noida",
    name: "Aryan Sood",
    role: "Contributor",
    bio: "Deals desk. Sees your cap table before you do.",
    photo:
      "https://images.unsplash.com/photo-1596129050968-24ea0d26f0ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    group: "Contributors",
  },
];

export const socialLinks = [
  { label: "Instagram", href: "#" },
  { label: "Twitter / X", href: "#" },
  { label: "LinkedIn", href: "#" },
  { label: "YouTube", href: "#" },
  { label: "Spotify", href: "#" },
];

// Legacy content arrays — no longer used for news (body content is now inline per article).
// Kept as exports for backward compatibility with articles.
export const COVERS = [];

export const PARAS = [];

export const PULL_QUOTE_TEMPLATES = [];
